{
  "common": {
    "cancel": "ரத்து செய்",
    "save": "சேமி",
    "logout": "வெளியேறு",
    "logoutConfirm": "நிச்சயமாக வெளியேற விரும்புகிறீர்களா?",
    "active": "செயலில்",
    "inactive": "செயலற்ற",
    "close": "மூடு",
    "confirm": "உறுதிப்படுத்து",
    "delete": "நீக்கு",
    "loading": "ஏற்றுகிறது…",
    "checking": "சரிபார்க்கிறது…",
    "saving": "சேமிக்கிறது…",
    "deleting": "நீக்குகிறது…",
    "yes": "ஆம்",
    "no": "இல்லை",
    "settingsMenu": "அமைப்புகள் மெனு",
    "reset": "மீட்டமை",
    "search": "தேடு",
    "previous": "முந்தைய",
    "next": "அடுத்த",
    "first": "முதல்",
    "last": "கடைசி",
    "noDataFound": "தரவு இல்லை",
    "noResultsFound": "முடிவுகள் இல்லை",
    "entries": "பதிவுகள்",
    "showingEntries": "{{total}} இல் {{from}} முதல் {{to}} வரை காட்டப்படுகிறது",
    "actions": "செயல்கள்",
    "status": "நிலை",
    "back": "பின்செல்",
    "print": "அச்சிடு",
    "edit": "திருத்து",
    "view": "காண்க",
    "supervisor": "மேற்பார்வையாளர்",
    "selectUser": "பயனரைத் தேர்ந்தெடுக்கவும்",
    "selectSupervisor": "மேற்பார்வையாளரைத் தேர்ந்தெடுக்கவும்",
    "failedToLoad": "ஏற்ற முடியவில்லை",
    "draft": "வரைவு",
    "to": "வரை",
    "rowsPerPage": "ஒரு பக்கத்திற்கு வரிசைகள்:",
    "selectedCount": "{{count}} தேர்ந்தெடுக்கப்பட்டது",
    "signIn": "உள்நுழை"
  },
  "languages": {
    "english": "English",
    "sinhala": "සිංහල",
    "tamil": "தமிழ்"
  },
  "validation": {
    "fieldRequired": "{{field}} தேவை.",
    "maxCharLimit": "அதிகபட்ச எழுத்து வரம்பு மீறப்பட்டது.",
    "dateFutureOnly": "தற்போதைய மற்றும் எதிர்கால தேதிகள் மட்டுமே அனுமதிக்கப்படும்.",
    "docReasonRequired": "கட்டாய ஆவணம் பதிவேற்றப்படாதபோது காரணம் தேவை.",
    "contactNumberDigitsOnly": "தொடர்பு எண்ணில் இலக்கங்கள் மட்டுமே இருக்க வேண்டும்.",
    "contactNumberExactLength": "தொடர்பு எண் {{count}} இலக்கங்களாக இருக்க வேண்டும்.",
    "contactNumberMustStartWithZero": "தொடர்பு எண் 0 இல் தொடங்க வேண்டும்.",
    "validContactNumber": "சரியான தொடர்பு எண்ணை உள்ளிடவும்.",
    "dateOfOffenceFuture": "குற்றம் நடந்த தேதி எதிர்காலத்தில் இருக்க முடியாது.",
    "addAtLeastOnePublicCorporationName": "குறைந்தது ஒரு பொது நிறுவன பெயரைச் சேர்க்கவும்."
  },
  "header": {
    "systemName": "வழக்கு மேலாண்மை அமைப்பு – AGD",
    "intranetPortal": "அக தளம்",
    "notifications": "அறிவிப்புகள்",
    "userProfile": "பயனர் சுயவிவரம்",
    "settings": "அமைப்புகள்",
    "info": "வழக்கு சூழல்கள்",
    "accountMenu": "கணக்கு மெனு",
    "profile": "சுயவிவரம்",
    "switchRole": "பங்கை மாற்று",
    "selectUserRole": "பயனர் பங்கைத் தேர்ந்தெடுக்கவும்",
    "switch": "மாற்று",
    "signOut": "வெளியேறு",
    "noRolesAvailable": "பங்குகள் எதுவும் இல்லை",
    "switchRoleFailed": "பங்கை மாற்ற முடியவில்லை. மீண்டும் முயற்சிக்கவும்."
  },
  "settings": {
    "theme": "தீம்",
    "mode": "முறை",
    "light": "ஒளி",
    "dark": "இருள்",
    "primary": "முதன்மை",
    "primaryColor": "முதன்மை நிறம்",
    "resetTheme": "தீமை மீட்டமை",
    "language": "மொழி"
  },
  "nav": {
    "expandNavigation": "வழிசெலுத்தலை விரிவாக்கு",
    "collapseNavigation": "வழிசெலுத்தலை சுருக்கு",
    "mainNavigation": "முதன்மை வழிசெலுத்தல்",
    "groups": {
      "dashboard": "டாஷ்போர்டு",
      "work": "வேலை",
      "operations": "செயல்பாடுகள்",
      "legalKnowledgeArchiveManagement": "சட்ட அறிவு காப்பக மேலாண்மை",
      "legalKnowledgeArchive": "சட்ட அறிவு காப்பகம்",
      "auditLogs": "தணிக்கை பதிவுகள்",
      "administration": "பயனர் நிர்வாகம்",
      "workflowManagement": "பணிப்பாய்வு மேலாண்மை",
      "reports": "அறிக்கைகள்",
      "metadata": "Metadata"
    },
    "tasksAndCases": "பணிகள் & வழக்குகள்",
    "caseDetails": "வழக்கு விவரங்கள்",
    "attendingTasksAndCases": "வழக்கு விவரங்கள்",
    "assignTasks": "பணிகளை ஒதுக்கு",
    "escalationTasks": "உயர்த்தல் பணிகள்",
    "sgDashboard": "SG டாஷ்போர்டு",
    "operationalDashboard": "செயல்பாட்டு",
    "caseRequests": "வழக்கு கோரிக்கைகள்",
    "mailRoom": "வழக்கு சமர்ப்பிப்பு கோரிக்கைகள்",
    "recordRoom": "முடிக்கப்பட்ட கோப்புகள்",
    "qrScanningLog": "QR ஸ்கேனிங் பதிவு",
    "legalKnowledge": "சட்ட அறிவு காப்பகம்",
    "extractedCaseOutcomes": "பிரித்தெடுக்கப்பட்ட வழக்கு முடிவுகள்",
    "dashboard": "டாஷ்போர்டு",
    "allIntranetUsers": "Intranet பயனர்கள்",
    "userCategories": "பயனர் வகைகள்",
    "allExtranetUsers": "Extranet பயனர்கள்",
    "rolesPermissions": "பயனர் பங்குகள் & அனுமதிகள்",
    "dashboards": "டாஷ்போர்டுகள்",
    "auditLogs": "தணிக்கை பதிவுகள்",
    "userPerformanceReport": "பயனர் செயல்திறன் அறிக்கை",
    "caseTrackingReport": "வழக்கு கண்காணிப்பு அறிக்கை",
    "workflowPerformanceReport": "பணிப்பாய்வு செயல்திறன் அறிக்கை",
    "workflowTemplates": "பணிப்பாய்வு வார்ப்புருக்கள்",
    "kpiConfiguration": "KPI கட்டமைப்பு",
    "escalationRules": "உயர்த்தல் விதிகள்",
    "subcategory": "துணை கோப்பு வகைகள்",
    "court": "நீதிமன்ற பெயர்கள்",
    "language": "மொழி வகைகள்",
    "country": "நாடுகள்",
    "nationality": "தேசியங்கள்",
    "policeStation": "போலீஸ் நிலையங்கள்",
    "letterTemplates": "கடிதம் வார்ப்புருக்கள்",
    "subsidiaryTasks": "துணைப் பணிகள்",
    "caseScenarios": "வழக்கு காட்சிகள்"
  },
  "profile": {
    "breadcrumb": "பயனர் சுயவிவரம்",
    "title": "பயனர் சுயவிவரம்",
    "upload": "பதிவேற்று",
    "delete": "நீக்கு",
    "name": "பெயர்",
    "emailUsername": "மின்னஞ்சல்/பயனர்பெயர்",
    "emailHint": "இந்த மின்னஞ்சல் முகவரி பயனர்பெயராக பயன்படுத்தப்படும்.",
    "userRole": "பயனர் பங்கு",
    "userRoles": "பயனர் பங்கு(கள்)",
    "divisionUnit": "பிரிவு / அலகு",
    "nicPassport": "தே.அ.அட்டை / கடவுச்சீட்டு எண்",
    "designation": "பதவி",
    "serviceId": "சேவை அடையாள எண்",
    "contactNumber": "தொடர்பு எண்",
    "contactPlaceholder": "எ.கா.: 07X XXX XXXX",
    "systemInformation": "அமைப்பு தகவல்",
    "createdAt": "உருவாக்கப்பட்ட நேரம்",
    "createdBy": "உருவாக்கியவர்",
    "lastUpdatedAt": "கடைசியாக புதுப்பிக்கப்பட்ட நேரம்",
    "lastUpdatedBy": "கடைசியாக புதுப்பித்தவர்",
    "loadingProfile": "சுயவிவரம் ஏற்றப்படுகிறது…",
    "loadFailed": "சுயவிவரத்தை ஏற்ற முடியவில்லை.",
    "saveSuccess": "சுயவிவரம் வெற்றிகரமாக புதுப்பிக்கப்பட்டது.",
    "saveFailed": "சுயவிவரத்தை சேமிக்க முடியவில்லை.",
    "uploadFailed": "சுயவிவர படத்தை பதிவேற்ற முடியவில்லை.",
    "invalidImage": "சரியான படக் கோப்பை (JPEG, PNG, அல்லது WebP) தேர்ந்தெடுக்கவும்.",
    "imageTooLarge": "படம் 2 MB அல்லது அதற்கு குறைவாக இருக்க வேண்டும்.",
    "profileImageAlt": "சுயவிவர புகைப்படம்",
    "deletePhotoTitle": "சுயவிவர புகைப்படத்தை அகற்று",
    "uploading": "பதிவேற்றுகிறது…",
    "uploadImage": "படத்தை பதிவேற்று",
    "maxCharLimit": "அதிகபட்ச எழுத்து வரம்பு மீறப்பட்டது.",
    "invalidNicPassport": "சரியான தே.அ.அட்டை அல்லது கடவுச்சீட்டு எண்ணை உள்ளிடவும்."
  },
  "confirmDelete": {
    "title": "நீக்குதலை உறுதிப்படுத்து",
    "message": "இந்த உருப்படியை நீக்க விரும்புகிறீர்களா? இந்த செயலை மீளமுடியாது.",
    "messageWithEntity": "{{entityLabel}} \"{{entityName}}\" ஐ நீக்கவா?"
  },
  "legalKnowledge": {
    "status": {
      "draft": "வரைவு",
      "published": "வெளியிடப்பட்டது",
      "rejected": "நிராகரிக்கப்பட்டது"
    },
    "archive": {
      "breadcrumb": "சட்ட அறிவு காப்பகம்",
      "title": "சட்ட அறிவு காப்பகம்",
      "subtitle": "வெளியிடப்பட்ட சட்ட அறிவு காப்பக பதிவுகளைத் தேடி பார்க்கவும்.",
      "tableTitle": "சட்ட அறிவு காப்பக விவரங்கள்",
      "colPublishedAt": "வெளியிடப்பட்ட தேதி",
      "publishedFrom": "வெளியிடப்பட்ட தேதி தொடக்கம்",
      "viewArchivedCaseDetailsTip": "காப்பக வழக்கு விவரங்களைப் பார்க்கவும்",
      "tabsAriaLabel": "சட்ட அறிவு பிரிவுகள்",
      "tabOutcomes": "பிரித்தெடுக்கப்பட்ட முடிவுகள்",
      "tabSearch": "காப்பகத்தைத் தேடு",
      "tabLinkages": "வழக்கு இணைப்புகள்",
      "tabDashboard": "டாஷ்போர்டு",
      "outcomesTableTitle": "பிரித்தெடுக்கப்பட்ட வழக்கு முடிவுகளின் பட்டியலைக் காண்க",
      "outcomesLegend": "வரைவு / வெளியிடப்பட்ட / நிராகரிக்கப்பட்ட பதிவுகள் (FR55)",
      "colCaseRef": "வழக்கு / கோரிக்கை Ref.",
      "colCaseType": "வழக்கு வகை",
      "colOutcomeTitle": "முடிவு தலைப்பு",
      "colPublicationStatus": "வெளியீட்டு நிலை",
      "colExtractedAt": "பிரித்தெடுக்கப்பட்ட நேரம்",
      "colRef": "Ref.",
      "colSummary": "சுருக்கம்",
      "colFromRef": "From Ref.",
      "colToRef": "To Ref.",
      "colLinkType": "இணைப்பு வகை",
      "colNotes": "குறிப்புகள்",
      "viewDetailsTip": "விவரங்களைக் காண்க",
      "reviewDraftTip": "வரைவை மதிப்பாய்வு செய்",
      "open": "திற",
      "metadataSearch": "Metadata தேடல்",
      "metadataSearchPlaceholder": "Ref., வழக்கு வகை, தலைப்பு, முக்கிய வார்த்தைகள்…",
      "fullTextSearch": "முழு-உரை தேடல்",
      "fullTextSearchPlaceholder": "சுருக்கம் அல்லது முழு விவரணத்தில் உள்ள வார்த்தைகள்…",
      "clear": "அழி",
      "searchResultsTitle": "தேடல் முடிவுகள்",
      "linkagesTableTitle": "தொடர்புடைய வழக்கு இணைப்புகள் (FR59)",
      "addLinkage": "இணைப்பைச் சேர்",
      "analyticsSummary": "சுருக்கம் (FR60)",
      "totalRecords": "மொத்த பதிவுகள்",
      "drafts": "வரைவுகள்",
      "recordsByCaseType": "வழக்கு வகை அடிப்படையில் பதிவுகள்",
      "archivedCaseDetails": "காப்பகப்படுத்தப்பட்ட வழக்கு விவரங்கள்",
      "reference": "குறிப்பு",
      "fullNarrative": "முழு விவரணம்",
      "relatedSimilarCases": "தொடர்புடைய / ஒத்த வழக்குகள் (FR58)",
      "noLinkedReferences": "இந்த பதிவில் இணைக்கப்பட்ட குறிப்புகள் இல்லை.",
      "reviewDraftTitle": "வழக்கு முடிவு வரைவை மதிப்பாய்வு செய் (FR56)",
      "outcomeText": "முடிவு உரை",
      "approvePublish": "அனுமதித்து வெளியிடு",
      "retainDraft": "வரைவைத் தக்க வை",
      "reject": "நிராகரி",
      "addCaseLinkage": "வழக்கு இணைப்பைச் சேர்",
      "fromReference": "From reference",
      "toReference": "To reference",
      "selectPlaceholder": "தேர்ந்தெடு…",
      "linkTypeRelatedPrecedent": "Related precedent",
      "linkTypeSimilarSubject": "Similar subject matter",
      "linkTypeFollowOn": "Follow-on matter",
      "chooseDifferentRefs": "வேறுபட்ட குறிப்பு எண்கள் இரண்டைத் தேர்ந்தெடுக்கவும்.",
      "linkageSavedMock": "இணைப்பு சேமிக்கப்பட்டது (mock).",
      "outcomePublishedMock": "முடிவு அனுமதிக்கப்பட்டு வெளியிடப்பட்டது (mock).",
      "draftRetained": "வரைவு தக்க வைக்கப்பட்டது.",
      "draftRejectedMock": "வரைவு நிராகரிக்கப்பட்டது (mock)."
    },
    "outcomes": {
      "title": "பிரித்தெடுக்கப்பட்ட வழக்கு முடிவுகள்",
      "tableTitle": "பிரித்தெடுக்கப்பட்ட வழக்கு முடிவு விவரங்கள்",
      "footerCountNoun": "முடிவுகள்",
      "colArchiveRefNo": "காப்பக Ref. No.",
      "colFileRefNo": "கோப்பு Ref. No.",
      "colFileCategory": "கோப்பு வகை",
      "colSubFileCategory": "துணை கோப்பு வகை",
      "colOutcomeExtractedAt": "முடிவு பிரித்தெடுக்கப்பட்ட நேரம்",
      "colCaseCompletedAt": "வழக்கு முடிக்கப்பட்ட நேரம்",
      "editTip": "வரைவைத் திருத்து",
      "editDraftTip": "வரைவைத் திருத்து",
      "viewArchivedTip": "காப்பக வழக்கு விவரங்களைப் பார்க்கவும்",
      "viewTip": "காப்பக வழக்கு விவரங்களைப் பார்க்கவும்",
      "archiveReferenceNumber": "காப்பக குறிப்பு எண்",
      "archiveReferenceNumberPlaceholder": "காப்பக குறிப்பு எண்ணை உள்ளிடவும்",
      "fileReferenceNumber": "கோப்பு குறிப்பு எண்",
      "fileReferenceNumberPlaceholder": "கோப்பு குறிப்பு எண்ணை உள்ளிடவும்",
      "fileCategories": "கோப்பு வகை(கள்)",
      "fileCategoriesPlaceholder": "கோப்பு வகை(களை)த் தேர்ந்தெடுக்கவும்",
      "subFileCategories": "துணை கோப்பு வகை(கள்)",
      "subFileCategoriesPlaceholder": "துணை கோப்பு வகை(களை)த் தேர்ந்தெடுக்கவும்",
      "statuses": "நிலை(கள்)",
      "statusesPlaceholder": "நிலை(களை)த் தேர்ந்தெடுக்கவும்",
      "enterText": "உரையை உள்ளிடவும்",
      "enterTextPlaceholder": "உரை அல்லது சொற்றொடரை உள்ளிடவும்",
      "caseCompletedFrom": "வழக்கு முடிக்கப்பட்ட தேதி முதல்",
      "outcomeExtractedFrom": "முடிவு பிரித்தெடுக்கப்பட்ட தேதி முதல்"
    },
    "categories": {
      "criminal": "குற்றவியல்",
      "civilDivisionAdvise": "சிவில் பிரிவு - ஆலோசனை",
      "civilDivisionLitigation": "சிவில் பிரிவு - வழக்கு",
      "civilAppellateDivision": "சிவில் மேல் முறையீட்டு பிரிவு",
      "criminalAppellateDivision": "குற்றவியல் மேல் முறையீட்டு பிரிவு",
      "extraditionMla": "கைது நாடு கடத்தல் & MLA",
      "rightToInformation": "தகவல் அறியும் உரிமை",
      "publicPetitions": "பொது மனுக்கள்",
      "nominationRequests": "நியமன கோரிக்கைகள்",
      "attorneyGeneralInternal": "பொது வழக்காளர் | AGD-அக"
    },
    "subCategories": {
      "offenceHumanBody": "மனித உடல்/உயிர் பாதிக்கும் குற்றம்",
      "offenceProperty": "சொத்துக்கு எதிரான குற்றம்",
      "generalLegalAdvice": "E - பொது சட்ட ஆலோசனை",
      "draftingAgreements": "E - ஒப்பந்த வரைவு",
      "originalCourt": "OC - மூல ந court",
      "writPetition": "WP - ரிட் மனு",
      "mutualLegalAssistance": "MLA - ப Ill legal assistance",
      "extradition": "EXT - கைது நாடு கடத்தல்",
      "courtOfAppeal": "COA - ம Appeal Court",
      "supremeCourt": "SC - உ supreme Court",
      "highCourtAppeals": "HC - உ High Court Appeals",
      "supremeCourtAppeals": "SC - உ supreme Court Appeals",
      "rtiGeneral": "RTI - ப Ill...",
      "ppCriminalMatter": "PP - குற்றவியல் விவகாரம்",
      "ppCivilMatter": "PP - சிவில் விவகாரம்"
    },
    "dashboardPage": {
      "title": "டாஷ்போர்டு",
      "loading": "ஏற்றப்படுகிறது…",
      "loadFailed": "டாஷ்போர்டு தரவை ஏற்ற முடியவில்லை.",
      "totalPublished": "மொத்த வெளியிடப்பட்டவை",
      "drafts": "வரைவுகள்",
      "rejected": "நிராகரிக்கப்பட்டவை",
      "totalPublishedDesc": "சட்ட அறிவு காப்பகத்தில் வெளியிடப்பட்ட பதிவுகளின் மொத்த எண்ணிக்கை",
      "draftsDesc": "வரைவு நிலையில் உள்ள பிரித்தெடுக்கப்பட்ட வழக்கு முடிவுகளின் எண்ணிக்கை",
      "rejectedDesc": "மதிப்பாய்வுக்குப் பின் நிராகரிக்கப்பட்ட பிரித்தெடுக்கப்பட்ட வழக்கு முடிவுகளின் எண்ணிக்கை",
      "today": "இன்று ({{date}})",
      "byCategoryTitle": "கோப்பு வகை & துணை கோப்பு வகை அடிப்படையில் வெளியிடப்பட்ட பதிவுகள்",
      "byCategoryDesc": "சட்ட அறிவு காப்பகத்தில் வெளியிடப்பட்ட அனைத்து பதிவுகளும் கோப்பு வகை & துணை கோப்பு வகை அடிப்படையில்",
      "byPeriodTitle": "கால அடிப்படையில் வெளியிடப்பட்ட பதிவுகள்",
      "byPeriodDesc": "சட்ட அறிவு காப்பகத்தில் வெளியிடப்பட்ட அனைத்து பதிவுகளும் கால அடிப்படையில்"
    },
    "viewOutcome": {
      "draftBreadcrumb": "பிரித்தெடுக்கப்பட்ட வழக்கு முடிவு வரைவு",
      "draftTitle": "பிரித்தெடுக்கப்பட்ட வழக்கு முடிவு வரைவு",
      "recordNotFound": "பதிவு கிடைக்கவில்லை.",
      "backToList": "பட்டியலுக்குத் திரும்பு",
      "retainAsDraft": "வரைவாகத் தக்க வை",
      "edit": "திருத்து",
      "approveAndPublish": "அனுமதித்து வெளியிடு",
      "backToListBtn": "பட்டியலுக்குத் திரும்பு",
      "caseOverview": "வழக்கு கண்ணோட்டம்",
      "archiveReferenceNumber": "Archive Reference Number",
      "fileReferenceNumber": "File Reference Number",
      "caseCompletedAt": "வழக்கு முடிக்கப்பட்ட நேரம்",
      "outcomeExtractedAt": "முடிவு பிரித்தெடுக்கப்பட்ட நேரம்",
      "fileCategory": "கோப்பு வகை",
      "subFileCategory": "துணை கோப்பு வகை",
      "applicableAreas": "பொருந்தக்கூடிய பகுதி(கள்)",
      "requestSubmittedAt": "கோரிக்கை சமர்ப்பிக்கப்பட்ட நேரம்",
      "submittedAgency": "சமர்ப்பித்த நிறுவனம்",
      "divisionName": "பிரிவின் பெயர்",
      "province": "மாகாணம்",
      "district": "மாவட்டம்",
      "caseNumber": "வழக்கு எண்",
      "otherExternalRefNos": "பிற வெளிப்புற Ref Nos",
      "connectedAgdFileRefNo": "இணைக்கப்பட்ட AGD கோப்பு Ref No",
      "description": "விளக்கம்",
      "courtDetails": "நீதிமன்ற விவரங்கள்",
      "courtType": "நீதிமன்ற வகை",
      "courtName": "நீதிமன்ற பெயர்",
      "incidentMatterDetails": "சம்பவம் / விஷய விவரங்கள்",
      "subjectOfDispute": "விவாதத்தின் பொருள்",
      "incidentOccurredDate": "சம்பவம் நடந்த தேதி",
      "applicableStatutes": "பொருந்தக்கூடிய சட்டம்(கள்)",
      "statutesPlaceholder": "பொருந்தக்கூடிய Acts, ordinances அல்லது பிற சட்ட விதிகள்",
      "notProvided": "வழங்கப்படவில்லை",
      "extractedOutcomeSummary": "பிரித்தெடுக்கப்பட்ட முடிவு சுருக்கம்",
      "summaryPlaceholder": "இந்த முடிக்கப்பட்ட வழக்கின் பிரித்தெடுக்கப்பட்ட முடிவு சுருக்கம்",
      "rejectedReason": "நிராகரிப்பு காரணம்",
      "caseLinkages": "வழக்கு இணைப்புகள்",
      "addLinkage": "+ இணைப்பைச் சேர்",
      "noCaseLinkages": "வழக்கு இணைப்புகள் சேர்க்கப்படவில்லை.",
      "editLinkageTip": "இணைப்பைத் திருத்து",
      "removeLinkageTip": "இணைப்பை அகற்று",
      "lastUpdatedAt": "கடைசியாக புதுப்பிக்கப்பட்ட நேரம்",
      "lastUpdatedBy": "கடைசியாக புதுப்பித்தவர்",
      "rejectModalTitle": "பிரித்தெடுக்கப்பட்ட வழக்கு முடிவு வரைவை நிராகரி",
      "rejectReason": "நிராகரிப்பு காரணம்",
      "rejectReasonPlaceholder": "நிராகரிப்பு காரணத்தை உள்ளிடவும்..",
      "rejectReasonRequired": "நிராகரிப்பு காரணம் தேவை.",
      "editCaseLinkage": "வழக்கு இணைப்பைத் திருத்து",
      "addNewCaseLinkage": "புதிய வழக்கு இணைப்பைச் சேர்",
      "linkToArchivedCase": "காப்பகப்படுத்தப்பட்ட வழக்குடன் இணை",
      "linkToArchivedCasePlaceholder": "இணைக்கப்பட்ட காப்பக வழக்கின் Archive Reference Number ஐத் தேர்ந்தெடுக்கவும்",
      "statutesRequired": "பொருந்தக்கூடிய சட்டம்(கள்) தேவை.",
      "summaryRequired": "பிரித்தெடுக்கப்பட்ட முடிவு சுருக்கம் தேவை.",
      "draftRetainedSuccess": "பிரித்தெடுக்கப்பட்ட வழக்கு முடிவு வரைவாக வைக்கப்பட்டது.",
      "saveFailed": "பிரித்தெடுக்கப்பட்ட வழக்கு முடிவைச் சேமிப்பது தோல்வி.",
      "publishSuccess": "பிரித்தெடுக்கப்பட்ட வழக்கு முடிவு அங்கீகரிக்கப்பட்டு வெளியிடப்பட்டது.",
      "publishFailed": "பிரித்தெடுக்கப்பட்ட வழக்கு முடிவை வெளியிடுவது தோல்வி.",
      "rejectSuccess": "பிரித்தெடுக்கப்பட்ட வழக்கு முடிவு நிராகரிக்கப்பட்டது.",
      "rejectFailed": "பிரித்தெடுக்கப்பட்ட வழக்கு முடிவை நிராகரிப்பது தோல்வி.",
      "linkageSavedSuccess": "வழக்கு இணைப்பு சேமிக்கப்பட்டது.",
      "linkageSaveFailed": "வழக்கு இணைப்பைச் சேமிப்பது தோல்வி.",
      "linkageRemovedSuccess": "வழக்கு இணைப்பு அகற்றப்பட்டது.",
      "linkageRemoveFailed": "வழக்கு இணைப்பை அகற்றுவது தோல்வி.",
      "rejectConfirmTitle": "நிராகரிப்பை உறுதிப்படுத்து",
      "rejectConfirmMessage": "இந்த பிரித்தெடுக்கப்பட்ட வழக்கு முடிவு வரைவை நிராகரிக்க விரும்புகிறீர்களா?",
      "cancelConfirmTitle": "ரத்தை உறுதிப்படுத்து",
      "cancelConfirmMessage": "மாற்றங்களைச் சேமிக்காமல் ரத்து செய்ய விரும்புகிறீர்களா?",
      "removeLinkageConfirmTitle": "வழக்கு இணைப்பை அகற்று",
      "removeLinkageConfirmMessage": "இந்த வழக்கு இணைப்பை அகற்ற விரும்புகிறீர்களா?"
    },
    "viewArchived": {
      "title": "காப்பக வழக்கு விவரங்களைப் பார்க்கவும்",
      "breadcrumb": "காப்பக வழக்கு விவரங்கள்",
      "back": "பின்செல்",
      "backToArchive": "சட்ட அறிவு காப்பகத்திற்குத் திரும்பு",
      "loadFailed": "காப்பக வழக்கு விவரங்களை ஏற்றுவது தோல்வி.",
      "rejectReasonLabel": "பிரித்தெடுக்கப்பட்ட வழக்கு முடிவு வரைவு நிராகரிப்பு காரணம்"
    }
  },
  "viewRequest": {
    "breadcrumbParent": "பணிகள் & வழக்குகள்",
    "title": "வழக்கு கோரிக்கையைக் காண்க",
    "fileReferenceNumber": "கோப்பு குறிப்பு எண்",
    "fileCategory": "கோப்பு வகை",
    "subFileCategory": "துணை கோப்பு வகை",
    "currentStatus": "தற்போதைய நிலை",
    "tabCaseDetails": "வழக்கு விவரங்கள்",
    "tabDocuments": "ஆவணங்கள்",
    "tabCommunications": "தொடர்புகள்",
    "loadingCaseRequest": "வழக்கு கோரிக்கை ஏற்றப்படுகிறது…",
    "loadingQr": "QR ஏற்றப்படுகிறது…",
    "qrAlt": "வழக்கு கோரிக்கை சுருக்கக் குறிப்பு QR code",
    "qrUnavailable": "QR code கிடைக்கவில்லை",
    "qrTip": "AGD க்கு உ physical கோப்பை ஒப்படைக்கும்போது சுருக்கக் குறிப்பு உடன் இந்த QR code ஐ வழங்கவும்.",
    "viewCoverNote": "சுருக்கக் குறிப்பைக் காண்க",
    "preparing": "தயாராகிறது…",
    "printCoverNote": "சுருக்கக் குறிப்பை அச்சிடு",
    "caseRequestIdMissing": "வழக்கு கோரிக்கை id காணவில்லை.",
    "loadFailed": "வழக்கு கோரிக்கையை ஏற்ற முடியவில்லை.",
    "notFound": "வழக்கு கோரிக்கை கிடைக்கவில்லை.",
    "coverNotePdfFailed": "சுருக்கக் குறிப்பு PDF ஏற்ற முடியவில்லை.",
    "inProgress": "செயல்பாட்டில்",
    "documentsLoadFailed": "ஆவணங்களை ஏற்ற முடியவில்லை.",
    "communicationsLoadFailed": "தொடர்புகளை ஏற்ற முடியவில்லை.",
    "loadingDocuments": "ஆவணங்கள் ஏற்றப்படுகின்றன…",
    "loadingCommunications": "தொடர்புகள் ஏற்றப்படுகின்றன…",
    "requestSubmittedAt": "கோரிக்கை சமர்ப்பிக்கப்பட்ட நேரம்",
    "applicableAreas": "பொருந்தக்கூடிய பகுதி(கள்)"
  },
  "caseRequests": {
    "breadcrumb": "வழக்கு கோரிக்கைகள்",
    "title": "வழக்கு கோரிக்கைகள்",
    "subtitle": "உங்கள் நிறுவனம் சமர்ப்பித்த அனைத்து கோரிக்கைகளின் நிலையையும் காண்க மற்றும் கண்காணிக்கவும்.",
    "createCaseRequest": "+ வழக்கு கோரிக்கையை உருவாக்கு",
    "activeTab": "செயலில் உள்ள வழக்குகள்",
    "completedTab": "முடிக்கப்பட்ட வழக்குகள்",
    "tableTitle": "வழக்கு கோரிக்கை விவரங்கள்",
    "newNotificationLegend": "புதிய அறிவிப்பு பெறப்பட்டது",
    "deleteTitle": "வழக்கு கோரிக்கையை நீக்கு",
    "deleteMessage": "நீக்க விரும்புகிறீர்களா? இந்த செயலை மீளமுடியாது.",
    "loadDraftFailed": "வரைவை ஏற்ற முடியவில்லை.",
    "deleteDraftFailed": "வரைவை நீக்க முடியவில்லை. மீண்டும் முயற்சிக்கவும்.",
    "deleteDraftSuccess": "வரைவு வெற்றிகரமாக நீக்கப்பட்டது.",
    "duplicateFailed": "வழக்கை நகலெடுக்க முடியவில்லை. மீண்டும் முயற்சிக்கவும்.",
    "duplicateSuccess": "வழக்கு வெற்றிகரமாக நகலெடுக்கப்பட்டது. புதிய வரைவு உருவாக்கப்பட்டது.",
    "coverNoteSubmittedOnly": "சுருக்கக் குறிப்பு சமர்ப்பிக்கப்பட்ட கோரிக்கைகளுக்கு மட்டுமே கிடைக்கும்.",
    "coverNoteLoadFailed": "சுருக்கக் குறிப்பை ஏற்ற முடியவில்லை.",
    "downloading": "பதிவிறக்குகிறது",
    "downloadPdf": "PDF ஆக பதிவிறக்கு",
    "viewRequest": "கோரிக்கையைக் காண்க",
    "coverNote": "சுருக்கக் குறிப்பு",
    "qrNote": "கோப்பு பெறுதல், கண்காணிப்பு மற்றும் சுருக்கக் குறிப்பு சரிபார்ப்புக்கான QR code.",
    "fileReferenceNumber": "கோப்பு குறிப்பு எண்",
    "requestSubmittedAt": "கோரிக்கை சமர்ப்பிக்கப்பட்ட நேரம்",
    "submittedAgency": "சமர்ப்பித்த நிறுவனம்",
    "subFileCategoryLabel": "துணை கோப்பு வகை: {{value}}",
    "summaryTitle": "கோரிக்கை விவரங்களின் சுருக்கம்",
    "caseSource": "வழக்கு மூலம்",
    "connectedRef": "இணைக்கப்பட்ட AGD கோப்பு குறிப்பு எண்",
    "accusedName": "குற்றம் சாட்டப்பட்டவர்/சந்தேக நபர் பெயர்",
    "applicableAreas": "பொருந்தக்கூடிய பகுதி(கள்)",
    "urgencyLevel": "அவசர நிலை",
    "deadline": "காலக்கெடு",
    "urgencyJustification": "அவசர நியாயப்படுத்தல்",
    "documentsDeclared": "அறிவிக்கப்பட்ட ஆவணங்கள்",
    "noCoverNote": "இந்த வழக்குக்கு சுருக்கக் குறிப்பு இல்லை.",
    "removing": "அகற்றுகிறது",
    "print": "அச்சிடு",
    "loadingCoverNote": "சுருக்கக் குறிப்பு ஏற்றப்படுகிறது…",
    "coverNoteUnavailable": "சுருக்கக் குறிப்பு விவரங்கள் கிடைக்கவில்லை.",
    "qrGenerationFailed": "QR உருவாக்கம் தோல்வியடைந்தது",
    "divisionUnit": "பிரிவு / அலகு",
    "statusLabels": {
      "submitted": "சமர்ப்பிக்கப்பட்டது",
      "draft": "வரைவு",
      "inProgress": "செயல்பாட்டில்",
      "registered": "பதிவு செய்யப்பட்டது",
      "review": "மதிப்பாய்வு",
      "completed": "முடிக்கப்பட்டது",
      "rejected": "நிராகரிக்கப்பட்டது",
      "notStarted": "தொடங்கப்படவில்லை"
    }
  },
  "wizard": {
    "createCaseRequest": "வழக்கு கோரிக்கையை உருவாக்கு",
    "createSubtitle": "புதிய வழக்கு கோரிக்கையை சமர்ப்பிக்க கீழே உள்ள படிவத்தை படிப்படியாக நிரப்பவும்.",
    "reviewBeforeSubmission": "சமர்ப்பிப்பதற்கு முன் மதிப்பாய்வு",
    "reviewTitle": "வழக்கு கோரிக்கை விவரங்களை மதிப்பாய்வு செய்",
    "reviewSubtitle": "AGD-க்கு இந்த கோரிக்கையை சமர்ப்பிப்பதற்கு முன் அனைத்து தகவல்களையும் மதிப்பாய்வு செய்யவும்.",
    "stepBarLabel": "படி {{num}}",
    "reviewStepLabel": "படி {{num}}",
    "childUnder16": "குழந்தை 16 வயதுக்கு குறைவு",
    "notAvailable": "கிடைக்கவில்லை",
    "accusedSuspect": "குற்றம் சாட்டப்பட்டவர் / சந்தேக நபர் {{num}}",
    "confirm": {
      "main": "மேலே உள்ள தகவல்கள் சரியானவை என்பதை உறுதிப்படுத்துகிறேன்",
      "hint": "AGD-க்கு இந்த கோரிக்கையை சமர்ப்பிப்பதற்கு முன் உறுதிப்படுத்தவும்."
    },
    "nav": {
      "back": "< பின்செல்",
      "next": "அடுத்த >",
      "saveAsDraft": "வரைவாக சேமி",
      "reviewBeforeSubmissionBtn": "சமர்ப்பிப்பதற்கு முன் மதிப்பாய்வு >",
      "submitRequest": "கோரிக்கையை சமர்ப்பி",
      "submitting": "சமர்ப்பிக்கிறது…",
      "cancelCaseRequest": "வழக்கு கோரிக்கையை ரத்து செய்",
      "cancelConfirm": "ரத்து செய்ய விரும்புகிறீர்களா? சேமிக்கப்படாத மாற்றங்கள் இழக்கப்படும்.",
      "draftSaved": "வழக்கு கோரிக்கை வரைவாக சேமிக்கப்பட்டது.",
      "draftSaveFailed": "வரைவை சேமிக்க முடியவில்லை.",
      "submitSuccess": "வழக்கு கோரிக்கை வெற்றிகரமாக சமர்ப்பிக்கப்பட்டது.",
      "submitFailed": "சமர்ப்பிப்பு தோல்வியடைந்தது.",
      "fillRequiredFields": "இந்த திரையில் அனைத்து தேவையான புலங்களையும் நிரப்பவும்."
    },
    "sections": {
      "caseCategorization": "வழக்கு வகைப்பாடு",
      "caseIntakeDetails": "வழக்கு பெறுதல் விவரங்கள்",
      "caseDetails": "வழக்கு விவரங்கள்",
      "categorization": "வகைப்பாடு",
      "victimDetails": "பாதிக்கப்பட்டவர் விவரங்கள்",
      "offenceDetails": "குற்றம் விவரங்கள்",
      "timeline": "காலவரிசை",
      "requestSubmitterDetails": "கோரிக்கை சமர்ப்பிப்பவர் விவரங்கள்",
      "physicalFileDeliveryMethod": "இயல்பு கோப்பு வழங்கல் முறை",
      "partyDetails": "தரப்பினர் விவரங்கள்",
      "incidentMatterDetails": "சம்பவம்/ விஷய விவரங்கள்",
      "requesterDetails": "கோரிக்கையாளர் விவரங்கள்",
      "informationRequestDetails": "தகவல் கோரிக்கை விவரங்கள்",
      "additionalInformation": "கூடுதல் தகவல்",
      "petitionerDetails": "மனுதாரர் விவரங்கள்",
      "respondentDetails": "பதில் கூறுபவர் விவரங்கள்",
      "accusedPersonDetails": "குற்றம் சாட்டப்பட்டவர் விவரங்கள்",
      "legalExtraditionCaseDetails": "சட்டம் மற்றும் நாடுகளிடையே ஒப்படைப்பு வழக்கு விவரங்கள்",
      "uploadDocuments": "ஆவணங்களை பதிவேற்று",
      "partiesInvolved": "தொடர்புடைய தரப்பினர்",
      "submission": "சமர்ப்பிப்பு"
    },
    "placeholders": {
      "selectFileCategory": "கோப்பு வகையைத் தேர்ந்தெடுக்கவும்",
      "selectSubFileCategory": "துணை கோப்பு வகையைத் தேர்ந்தெடுக்கவும்",
      "selectApplicableAreas": "பொருந்தக்கூடிய பகுதி(களை) தேர்ந்தெடுக்கவும்",
      "briefDescriptionOfCase": "வழக்கின் சுருக்க விளக்கம்",
      "sourceOfCase": "வழக்கின் மூலம்",
      "selectProvince": "மாகாணத்தைத் தேர்ந்தெடுக்கவும்",
      "selectDistrict": "மாவட்டத்தைத் தேர்ந்தெடுக்கவும்",
      "selectCountry": "நாட்டைத் தேர்ந்தெடுக்கவும்",
      "loadingCountries": "நாடுகள் ஏற்றப்படுகின்றன…",
      "incomingOutgoing": "உள்வரும் / வெளிச்செல்லும்",
      "policeMagistrateRef": "காவல் / மாஜிஸ்ட்ரேட் குறிப்பு எண்",
      "commaSeparatedReferences": "கமாவால் பிரிக்கப்பட்ட குறிப்புகள்",
      "courtReferenceNumber": "நீதிமன்ற குறிப்பு எண்",
      "connectedAgdHint": "தொடர்புடைய AGD கோப்பு குறிப்பு எண் தெரியவில்லை என்றால், 'கிடைக்கிறது' checkbox ஐ தேர்ந்தெடுக்கவும்.",
      "briefDescriptionAdviceSought": "சுருக்க விளக்கம் — கோரப்பட்ட ஆலோசனை",
      "selectCorporateInstitute": "பொது நிறுவனத்தைத் தேர்ந்தெடுக்கவும்",
      "enterOtherInstituteName": "பிற நிறுவன பெயரை உள்ளிடவும்",
      "enterExternalReferenceNumber": "வெளிப்புற குறிப்பு எண்ணை உள்ளிடவும்",
      "commaSeparatedReferenceNumbers": "கமாவால் பிரிக்கப்பட்ட குறிப்பு எண்கள்",
      "includeConnectedCaseDetails": "தொடர்புடைய வழக்கு விவரங்களை சேர்க்கவும்",
      "enterConnectedCaseNumber": "தொடர்புடைய வழக்கு எண்ணை உள்ளிடவும்",
      "enterConnectedAgdFileRef": "தொடர்புடைய AGD கோப்பு குறிப்பு எண்ணை உள்ளிடவும்",
      "uploadDocument": "ஆவணத்தை பதிவேற்று",
      "enterAccusedName": "குற்றம் சாட்டப்பட்டவரின் பெயரை உள்ளிடவும்",
      "enterVictimName": "பாதிக்கப்பட்டவரின் பெயரை உள்ளிடவும்",
      "selectNationality": "தேசியத்தைத் தேர்ந்தெடுக்கவும்",
      "loadingNationalities": "தேசியங்கள் ஏற்றப்படுகின்றன…",
      "selectCountryOfOrigin": "தாய் நாட்டைத் தேர்ந்தெடுக்கவும்",
      "selectGender": "பாலினத்தைத் தேர்ந்தெடுக்கவும்",
      "selectCustodyStatus": "காவல் நிலையைத் தேர்ந்தெடுக்கவும்",
      "loadingCustodyStatuses": "காவல் நிலைகள் ஏற்றப்படுகின்றன…",
      "custodialAuthorityHint": "CID அல்லது தொடர்புடைய சட்ட அமலாக்க அமைப்பு",
      "selectUrgencyLevel": "அவசர நிலையைத் தேர்ந்தெடுக்கவும்",
      "urgencyJustificationReason": "வழக்குக்கு அவசர கவனம் தேவைப்படுவதற்கான காரணம்",
      "docSkipReason": "காரணத்தை உள்ளிடவும் (ஆவணம் பதிவேற்றப்படவில்லை என்றால் குறிப்பிடவும்)",
      "specifyDeliveryMethod": "வழங்கல் முறையைக் குறிப்பிடவும்",
      "enterPlaintiffApplicantName": "வாதி / விண்ணப்பதாரர் பெயரை உள்ளிடவும்",
      "enterDefendantRespondentName": "பிரதிவாதி / பதில் கூறுபவர் பெயரை உள்ளிடவும்",
      "enterLegalOfficerNameInCharge": "சட்ட அதிகாரி/ பொறுப்பு அதிகாரியின் பெயரை உள்ளிடவும்",
      "otherRelatedInstitutionsHint": "விஷயத்துடன் தொடர்புடைய பிற நிறுவனங்கள்",
      "enterInstitutionName": "நிறுவன பெயரை உள்ளிடவும்",
      "addCorporation": "+ சேர்",
      "remove": "நீக்கு",
      "contactNumberExample": "07XXXXXXXX",
      "otherRelatedInstitutionsPublicPrivateHint": "விஷயத்துடன் தொடர்புடைய பிற பொது அல்லது தனியார் நிறுவனங்கள்",
      "specifyCourtType": "நீதிமன்ற வகையைக் குறிப்பிடவும்",
      "enterCourtName": "நீதிமன்றத்தின் பெயரை உள்ளிடவும்",
      "nameOfTheCourt": "நீதிமன்றத்தின் பெயர்",
      "detailedLegalIssueDescription": "சட்ட விஷயத்தின் விரிவான விளக்கம்",
      "selectNextStep": "அடுத்த படியைத் தேர்ந்தெடுக்கவும்",
      "enterNextStepOther": "வழக்கின் பிற அடுத்த படியை உள்ளிடவும்",
      "enterRespondentNames": "பதில் கூறுபவர் பெயர்(களை) உள்ளிடவும்",
      "enterRespondentAddress": "பதில் கூறுபவர் முகவரியை உள்ளிடவும்",
      "enterNumberOfRespondents": "பதில் கூறுபவர்களின் எண்ணிக்கையை உள்ளிடவும்",
      "enterPetitionerName": "பெயரை உள்ளிடவும்",
      "enterAttorneyName": "வழக்கறிஞர் பெயரை உள்ளிடவும்",
      "selectRespondentType": "பதில் கூறுபவர் வகையைத் தேர்ந்தெடுக்கவும்",
      "enterRequestorName": "கோரிக்கையாளரின் பெயரை உள்ளிடவும்",
      "enterNicOrPassport": "NIC அல்லது passport எண்ணை உள்ளிடவும்",
      "enterAddress": "முகவரியை உள்ளிடவும்",
      "enterEmailAddress": "மின்னஞ்சல் முகவரியை உள்ளிடவும்",
      "enterPublicAuthorityName": "பொது அதிகாரியின் பெயரை உள்ளிடவும்",
      "describeRequestedInformation": "கோரப்படும் தகவலை விவரிக்கவும்",
      "enterTimePeriodIfApplicable": "காலகட்டத்தை உள்ளிடவும் (பொருந்தினால்)",
      "selectPreferredLanguage": "விருப்ப மொழியைத் தேர்ந்தெடுக்கவும்",
      "provideJustification": "நியாயப்படுத்தலை வழங்கவும்",
      "additionalNotesOptional": "கூடுதல் குறிப்புகள் (விரும்பினால்)",
      "enterPlaceOfOffence": "குற்றம் நடந்த இடத்தை உள்ளிடவும்",
      "enterAccusedSuspectName": "குற்றம் சாட்டப்பட்டவர்/சந்தேக நபர் பெயரை உள்ளிடவும்",
      "selectStatus": "நிலையைத் தேர்ந்தெடுக்கவும்",
      "specifyStatus": "நிலையைக் குறிப்பிடவும்",
      "enterUrgencyJustification": "அவசர நியாயப்படுத்தலை உள்ளிடவும்",
      "caseSourceOther": "வழக்கு மூலம் (பிற)",
      "selectMagistrateCourt": "மாஜிஸ்ட்ரேட் நீதிமன்றத்தைத் தேர்ந்தெடுக்கவும்",
      "selectHighCourt": "உயர் நீதிமன்றத்தைத் தேர்ந்தெடுக்கவும்",
      "selectPoliceStation": "காவல் நிலையத்தைத் தேர்ந்தெடுக்கவும்"
    },
    "fields": {
      "fileCategory": "கோப்பு வகை",
      "subFileCategory": "துணை கோப்பு வகை",
      "applicableAreas": "பொருந்தக்கூடிய பகுதி(கள்)",
      "available": "கிடைக்கிறது",
      "description": "விளக்கம்",
      "caseSource": "வழக்கு மூலம்",
      "province": "மாகாணம்",
      "district": "மாவட்டம்",
      "highCourtName": "உயர் நீதிமன்ற பெயர்",
      "magistrateCourtName": "மாஜிஸ்ட்ரேட் நீதிமன்ற பெயர்",
      "policeStation": "காவல் நிலையம்",
      "yourReferenceNumber": "உங்கள் குறிப்பு எண் (வெளிப்புற)",
      "otherExternalReferences": "பிற வெளிப்புற குறிப்பு எண்(கள்)",
      "caseNumber": "வழக்கு எண்",
      "connectedMatters": "இணைக்கப்பட்ட விஷயங்கள் (வழக்குகள்) உள்ளனவா?",
      "connectedMattersShort": "இணைக்கப்பட்ட விஷயங்கள்",
      "connectedCaseNumber": "இணைக்கப்பட்ட வழக்கு எண்",
      "connectedAgdFileRef": "இணைக்கப்பட்ட AGD கோப்பு குறிப்பு எண்",
      "victimName": "பாதிக்கப்பட்டவரின் பெயர்",
      "dateOfBirth": "பிறந்த தேதி",
      "age": "வயது",
      "gender": "பாலினம்",
      "dateOfOffence": "குற்றம் நடந்த தேதி",
      "placeOfOffence": "குற்றம் நடந்த இடம்",
      "accusedDetailsAvailable": "குற்றம் சாட்டப்பட்டவர்/சந்தேக நபர் விவரங்கள் உள்ளனவா",
      "accusedSuspects": "குற்றம் சாட்டப்பட்டவர் / சந்தேக நபர்கள்",
      "urgencyLevel": "அவசர நிலை",
      "deadline": "காலக்கெடு",
      "deadlineIfAny": "காலக்கெடு (இருந்தால்)",
      "urgencyJustification": "அவசர நியாயப்படுத்தல்",
      "submittedDivisionUnit": "சமர்ப்பிக்கப்பட்ட பிரிவு/ அலகு",
      "submittedDivisionUnitNoSpace": "சமர்ப்பிக்கப்பட்ட பிரிவு/அலகு",
      "submittedAgencyName": "சமர்ப்பிக்கப்பட்ட நிறுவன பெயர்",
      "designation": "பதவி",
      "submittedBy": "சமர்ப்பித்தவர்",
      "emailAddress": "மின்னஞ்சல் முகவரி",
      "contactNumber": "தொடர்பு எண்",
      "physicalFileDeliveryMethod": "இயல்பு கோப்பு வழங்கல் முறை",
      "deliveryMethod": "வழங்கல் முறை",
      "otherDeliveryMethod": "பிற வழங்கல் முறை",
      "instituteType": "நிறுவன வகை",
      "appealMatter": "Appeal Matter",
      "originalCourt": "அசல் நீதிமன்றம்",
      "judgementOrder": "தீர்ப்பு / உத்தரவு",
      "corporateInstitute": "பொது நிறுவனம்",
      "otherInstituteName": "பிற நிறுவன பெயர்",
      "plaintiffApplicantName": "வாதி / விண்ணப்பதாரர் பெயர்",
      "defendantRespondentName": "பிரதிவாதி / பதில் கூறுபவர் பெயர்",
      "selectOneOfFollowing": "பின்வருவனில் ஒன்றைத் தேர்ந்தெடுக்கவும்",
      "otherInvolvedInstitutions": "பிற தொடர்புடைய நிறுவனங்கள்",
      "legalOfficerName": "சட்ட அதிகாரி / பொறுப்பதிகாரி  பெயர்",
      "legalOfficerNameAlt": "சட்ட அதிகாரி/ பொறுப்பு அதிகாரியின் பெயர்",
      "hasActionInstituted": "நடவடிக்கை தொடங்கப்பட்டுள்ளதா?",
      "courtType": "நீதிமன்ற வகை",
      "courtTypeOther": "நீதிமன்ற வகை (பிற)",
      "courtName": "நீதிமன்ற பெயர்",
      "publicCorporationNames": "பொது நிறுவன பெயர்(கள்)",
      "publicCorporationName": "பொது நிறுவன பெயர்",
      "subjectOfDispute": "வழக்கின் பொருள்",
      "incidentOccurredDate": "சம்பவம் நடந்த தேதி",
      "nextStepOfCase": "வழக்கின் அடுத்த படி",
      "nextDateOfCase": "வழக்கின் அடுத்த தேதி",
      "countryInvolved": "தொடர்புடைய நாடு",
      "directionOfRequest": "கோரிக்கையின் திசை",
      "accusedName": "குற்றம் சாட்டப்பட்டவரின் பெயர்",
      "nationality": "தேசியம்",
      "countryOfOrigin": "தாய் நாடு",
      "passportIdNumber": "Passport/ID எண்",
      "currentCustodyStatus": "தற்போதைய காவல் நிலை",
      "custodialAuthority": "காவல் அதிகாரம்",
      "lastKnownLocation": "கடைசியாக அறியப்பட்ட இடம்",
      "arrestWarrantAvailable": "கைது உத்தரவு உள்ளதா",
      "warrantReference": "Warrant Reference",
      "applicableTreatyArrangement": "பொருந்தக்கூடிய ஒப்பந்தம்/ஏற்பாடு",
      "requestorName": "கோரிக்கையாளரின் பெயர்",
      "nicPassportNumber": "NIC/ Passport எண்",
      "isSriLankanCitizen": "கோரிக்கையாளர் இலங்கை குடிய citizen-ஆ?",
      "address": "முகவரி",
      "specificPublicAuthorityName": "Specific Public Authority Name",
      "informationRequestedTimePeriod": "Information Requested Time Period",
      "requestedInformationDetails": "Requested Information Details",
      "preferredMethodOfAccess": "Preferred Method of Access",
      "preferredLanguageForResponse": "Preferred Language for Response",
      "involvesLifeOrPersonalLiberty": "Does this request involve life or personal liberty of a citizen?",
      "justification": "Justification",
      "additionalNotes": "Additional Notes",
      "caseMatter": "Case Matter",
      "name": "பெயர்",
      "nicIdentificationNumber": "NIC / Identification Number",
      "email": "Email",
      "representedByAttorney": "Represented by Attorney",
      "attorneyName": "Attorney Name",
      "attorneyContactNumber": "Attorney's Contact Number",
      "respondentNames": "Respondent Name(s)",
      "respondentType": "Respondent Type",
      "numberOfRespondents": "Number of Respondents",
      "respondentAddress": "Respondent Address",
      "partyBodyType": "Party Body Type",
      "status": "Status",
      "petitionerName": "Petitioner Name",
      "nic": "NIC",
      "attorneyContact": "Attorney Contact",
      "citizenOfSriLanka": "Citizen of Sri Lanka",
      "involvesLifeOrPersonalLibertyShort": "Involves Life or Personal Liberty",
      "hasPreviousAdvice": "முன்னர் ஆலோசனை பெறப்பட்டுள்ளதா?",
      "hasPreviousAdviceOnMatter": "இந்த விஷயத்தில் முன்னர் ஆலோசனை பெறப்பட்டுள்ளதா?",
      "previousAdviceAttachment": "முந்தைய ஆலோசனை இணைப்பு",
      "previousAdviceAttachmentIfYes": "ஆம் என்றால், முந்தைய ஆலோசனையை இணைக்கவும்",
      "connectedCaseRelevant": "கோரப்பட்ட ஆலோசனை தொடர்பான இணைக்கப்பட்ட வழக்கு உள்ளதா?",
      "connectedCaseDetails": "ஆம் என்றால், வழக்கு விவர அம்சத்தை (தரப்பினர் விவரங்கள்) சேர்க்கவும்",
      "connectedAdviceCase": "இணைக்கப்பட்ட ஆலோசனை வழக்கா?",
      "connectedAdviceCaseDetails": "Connected Advice Case Details",
      "isAppealMatter": "Is this an appeal matter?",
      "judgementOrderShort": "Judgement/Order",
      "governmentDepartment": "அரசு துறை",
      "corporation": "நிறுவனம்",
      "criminalMatter": "Criminal Matter",
      "civilMatter": "Civil Matter",
      "governmentMinistryDepartment": "அரசு அமைச்சகம் / துறை / பிற சட்ட இணைப்பு இல்லாத நிறுவனம்",
      "publicCorporationStatutory": "பொது நிறுவனம் / சட்ட வாரியம் / அரசு உரிமை நிறுவனம் / பிற சட்ட இணைப்புடைய நிறுவனம்",
      "governmentMinistryDepartmentAlt": "அரசு அமைச்சகம்/ துறை/ பிற சட்ட இணைப்பு இல்லாத நிறுவனம்",
      "publicCorporationStatutoryAlt": "பொது நிறுவனம்/ சட்ட வாரியம்/ அரசு உரிமை நிறுவனம்/ பிற சட்ட இணைப்புடைய நிறுவனம்",
      "accusedSuspectName": "குற்றம் சாட்டப்பட்டவர் / சந்தேக நபர் பெயர்",
      "accusedSuspectStatus": "குற்றம் சாட்டப்பட்டவர் / சந்தேக நபர் நிலை",
      "statusOther": "நிலை (பிற)",
      "reason": "காரணம்",
      "petitionerAddress": "மனுதாரர் முகவரி",
      "nextStepOther": "வழக்கின் பிற அடுத்த படி",
      "preferredLanguage": "விருப்ப மொழி",
      "connectedMattersAdvises": "இணைக்கப்பட்ட விஷயங்கள் (ஆலோசனைகள்/வழக்குகள்) உள்ளனவா?"
    },
    "documents": {
      "documentType": "ஆவண வகை",
      "status": "நிலை",
      "fileOrReason": "கோப்பு / காரணம்",
      "uploaded": "பதிவேற்றப்பட்டது",
      "notUploaded": "பதிவேற்றப்படவில்லை",
      "noDocumentsDeclared": "ஆவணங்கள் அறிவிக்கப்படவில்லை.",
      "uploading": "பதிவேற்றுகிறது…",
      "loadingChecklist": "ஆவண சரிபார்ப்பு பட்டியல் ஏற்றப்படுகிறது…",
      "selectCategoryForDocs": "தேவையான ஆவணங்களை ஏற்ற கோப்பு வகையைத் தேர்ந்தெடுக்கவும்.",
      "noDocsConfigured": "தேர்ந்தெடுக்கப்பட்ட துணை கோப்பு வகைக்கு ஆவணங்கள் கட்டமைக்கப்படவில்லை."
    },
    "edit": "திருத்து",
    "criminal": {
      "steps": {
        "1": "வழக்கு கண்ணோட்டம்",
        "2": "பாதிக்கப்பட்டவர் விவரங்கள்",
        "3": "குற்றம் & குற்றம் சாட்டப்பட்டவர் விவரங்கள்",
        "4": "சமர்ப்பிப்பு & இயல்பு கோப்பு வழங்கல்",
        "5": "ஆவணங்களை பதிவேற்று"
      }
    },
    "criminalAppellate": {
      "steps": {
        "1": "வழக்கு கண்ணோட்டம்",
        "2": "தரப்பினர் விவரங்கள்",
        "3": "காலவரிசை",
        "4": "சமர்ப்பிப்பு & இயல்பு கோப்பு வழங்கல்",
        "5": "ஆவணங்களை பதிவேற்று"
      }
    },
    "civilLitigation": {
      "steps": {
        "1": "வழக்கு கண்ணோட்டம்",
        "2": "தரப்பினர் விவரங்கள்",
        "3": "சம்பவ விவரங்கள்",
        "4": "சமர்ப்பிப்பு & இயல்பு கோப்பு வழங்கல்",
        "5": "ஆவணங்களை பதிவேற்று"
      }
    },
    "civilAppellate": {
      "steps": {
        "1": "வழக்கு கண்ணோட்டம்",
        "2": "தரப்பினர் விவரங்கள்",
        "3": "காலவரிசை",
        "4": "சமர்ப்பிப்பு & இயல்பு கோப்பு வழங்கல்",
        "5": "ஆவணங்களை பதிவேற்று"
      }
    },
    "civilAdvise": {
      "steps": {
        "1": "வழக்கு கண்ணோட்டம்",
        "2": "காலவரிசை",
        "3": "சமர்ப்பிப்பு & இயல்பு கோப்பு வழங்கல்",
        "4": "ஆவணங்களை பதிவேற்று"
      }
    },
    "attorneyGeneral": {
      "steps": {
        "1": "வழக்கு கண்ணோட்டம்",
        "2": "தரப்பினர் விவரங்கள்",
        "3": "சம்பவ விவரங்கள்",
        "4": "பாதிக்கப்பட்டவர் விவரங்கள்",
        "5": "குற்றம் & குற்றம் சாட்டப்பட்டவர் விவரங்கள்",
        "6": "குற்றம் சாட்டப்பட்டவர் விவரங்கள் - Extradition & MLA",
        "7": "சட்டம் மற்றும் நாடுகளிடையே ஒப்படைப்பு",
        "8": "மனுதாரர் விவரங்கள்",
        "9": "Right to Information",
        "10": "காலவரிசை",
        "11": "சமர்ப்பிப்பு",
        "12": "ஆவணங்களை பதிவேற்று"
      },
      "stepLines": {
        "5": "குற்றம் & குற்றம் சாட்டப்பட்டவர்\nவிவரங்கள்",
        "6": "குற்றம் சாட்டப்பட்டவர் விவரங்கள்\nExtradition & MLA",
        "7": "சட்டம் மற்றும்\nநாடுகளிடையே ஒப்படைப்பு",
        "8": "மனுதாரர்\nவிவரங்கள்",
        "9": "Right to\nInformation",
        "12": "ஆவணங்களை\nபதிவேற்று"
      }
    },
    "extraditionMla": {
      "steps": {
        "1": "வழக்கு கண்ணோட்டம்",
        "2": "குற்றம் சாட்டப்பட்டவர் விவரங்கள்",
        "3": "சட்டம் மற்றும் நாடுகளிடையே ஒப்படைப்பு",
        "4": "காலவரிசை",
        "5": "சமர்ப்பிப்பு & இயல்பு கோப்பு வழங்கல்",
        "6": "ஆவணங்களை பதிவேற்று"
      },
      "reviewSteps": {
        "1categorization": "வகைப்பாடு",
        "1intake": "வழக்கு பெறுதல் விவரங்கள்",
        "3": "சட்டம் மற்றும் நாடுகளிடையே ஒப்படைப்பு வழக்கு விவரங்கள்"
      }
    },
    "nomination": {
      "steps": {
        "1": "வழக்கு கண்ணோட்டம்",
        "2": "காலவரிசை",
        "3": "சமர்ப்பிப்பு & இயல்பு கோப்பு வழங்கல்",
        "4": "ஆவணங்களை பதிவேற்று"
      }
    },
    "publicPetition": {
      "steps": {
        "1": "வழக்கு கண்ணோட்டம்",
        "2": "தொடர்புடைய தரப்பினர்",
        "3": "காலவரிசை",
        "4": "சமர்ப்பிப்பு & இயல்பு கோப்பு வழங்கல்",
        "5": "ஆவணங்களை பதிவேற்று"
      }
    },
    "rightToInformation": {
      "steps": {
        "1": "வழக்கு கண்ணோட்டம்",
        "2": "காலவரிசை",
        "3": "சமர்ப்பிப்பு",
        "4": "ஆவணங்களை பதிவேற்று"
      }
    }
  },
  "admin": {
    "userAdministration": "பயனர் நிர்வாகம்",
    "shared": {
      "code": "குறியீடு",
      "description": "விளக்கம்",
      "cancelChanges": "மாற்றங்களை ரத்துசெய்",
      "cancelChangesMessage": "ரத்துசெய்ய விரும்புகிறீர்களா? சேமிக்கப்படாத மாற்றங்கள் இழக்கப்படும்.",
      "requestFailed": "கோரிக்கை தோல்வியடைந்தது.",
      "invalidEmail": "சரியான மின்னஞ்சல் முகவரியை உள்ளிடவும்.",
      "add": "சேர்",
      "adding": "சேர்க்கிறது…",
      "removeImage": "படத்தை அகற்று",
      "upload": "பதிவேற்று",
      "imageUploadFailed": "படம் பதிவேற்றம் தோல்வியடைந்தது.",
      "displayName": "காட்சி பெயர்",
      "selectStatus": "நிலையைத் தேர்ந்தெடுக்கவும்",
      "emailPlaceholderShort": "மின்னஞ்சல்/பயனர்பெயரை உள்ளிடவும்",
      "agencyName": "நிறுவன பெயர்",
      "roleName": "பங்கு பெயர்",
      "applicationName": "பயன்பாட்டு பெயர்",
      "applicationNames": "பயன்பாட்டு பெயர்(கள்)",
      "assignedUsers": "назначен பயனர்கள்",
      "fileCategory": "கோப்பு வகை",
      "subFileCategory": "துணை கோப்பு வகை",
      "supervisor": "மேற்பார்வையாளர்",
      "selectAllPermissions": "அனைத்து அனுமதிகளையும் தேர்ந்தெடு",
      "basicInformation": "அடிப்படை தகவல்",
      "orderIndex": "வரிசை குறியீடு",
      "dragToReorder": "மறுவரிசைப்படுத்த இழுக்கவும்",
      "locked": "பூட்டப்பட்டது",
      "loadingOrder": "வரிசை ஏற்றுகிறது…",
      "noPermissionsConfigured": "அனுமதிகள் கட்டமைக்கப்படவில்லை.",
      "selectedCount": "{{count}} தேர்ந்தெடுக்கப்பட்டது",
      "newRole": "புதிய பங்கு",
      "rolePermissions": "பங்கு அனுமதிகள்",
      "applicationCannotChange": "புதுப்பிப்பின் போது பயன்பாட்டை மாற்ற முடியாது."
    },
    "intranetUsers": {
      "title": "Intranet பயனர்கள்",
      "addNewUser": "+ புதிய பயனர் சேர்",
      "tableTitle": "Intranet பயனர் விவரங்கள்",
      "selectUserName": "பயனர் பெயரைத் தேர்ந்தெடுக்கவும்",
      "selectUserRole": "பயனர் பங்கைத் தேர்ந்தெடுக்கவும்",
      "selectDivisionUnit": "பிரிவு/அலகைத் தேர்ந்தெடுக்கவும்",
      "emailPlaceholder": "மின்னஞ்சல்/பயனர்பெயரை உள்ளிடவும்",
      "selectStatus": "நிலையைத் தேர்ந்தெடுக்கவும்",
      "filterByUserName": "பயனர் பெயரால் வடிகட்டு",
      "userDetails": "பயனர் விவரங்கள்",
      "deleteTitle": "பயனரை நீக்கு",
      "entityLabel": "பயனர்",
      "editUser": "பயனரைத் திருத்து",
      "deleteUser": "பயனரை நீக்கு",
      "loadFailed": "பயனர்களை ஏற்ற முடியவில்லை.",
      "deleteSuccess": "பயனர் வெற்றிகரமாக நீக்கப்பட்டார்.",
      "deleteFailed": "பயனரை நீக்க முடியவில்லை.",
      "footerCountNoun": "பயனர்கள்"
    },
    "extranetUsers": {
      "title": "Extranet பயனர்கள்",
      "addNewUser": "+ புதிய பயனர் சேர்",
      "tableTitle": "Extranet பயனர் விவரங்கள்",
      "selectAgencyName": "நிறுவன பெயரைத் தேர்ந்தெடுக்கவும்",
      "agencyUserFullName": "நிறுவன பயனரின் முழு பெயர்",
      "editUser": "பயனரைத் திருத்து",
      "deleteUser": "பயனரை நீக்கு",
      "deleteTitle": "பயனரை நீக்கு",
      "entityLabel": "பயனர்",
      "loadFailed": "பயனர்களை ஏற்ற முடியவில்லை.",
      "deleteSuccess": "பயனர் வெற்றிகரமாக நீக்கப்பட்டார்.",
      "deleteFailed": "பயனரை நீக்க முடியவில்லை.",
      "footerCountNoun": "பயனர்கள்"
    },
    "rolesPermissions": {
      "title": "பயனர் பங்குகள் & அனுமதிகள்",
      "addNewRole": "+ புதிய பங்கு சேர்",
      "tableTitle": "பயனர் பங்கு விவரங்கள்",
      "selectRoleName": "பங்கு பெயரைத் தேர்ந்தெடுக்கவும்",
      "selectApplicationName": "பயன்பாட்டு பெயரைத் தேர்ந்தெடுக்கவும்",
      "updateRoleDetails": "பங்கு விவரங்களை புதுப்பி",
      "viewRoleDetails": "பங்கு விவரங்களை பார்",
      "updateNotAllowed": "இந்த பங்குக்கு புதுப்பிப்பு அனுமதிக்கப்படவில்லை.",
      "updateNotAllowedAria": "பங்கு விவரங்களை புதுப்பி (அனுமதி இல்லை)",
      "deleteRole": "பங்கை நீக்கு",
      "deleteTitle": "பங்கை நீக்கு",
      "entityLabel": "பங்கு",
      "roleDeletedSuccess": "பங்கு வெற்றிகரமாக நீக்கப்பட்டது.",
      "roleDeleteFailed": "பங்கை நீக்க முடியவில்லை.",
      "roleCreatedSuccess": "பங்கு வெற்றிகரமாக உருவாக்கப்பட்டது.",
      "roleUpdatedSuccess": "பங்கு வெற்றிகரமாக புதுப்பிக்கப்பட்டது."
    },
    "userCategories": {
      "title": "பயனர் வகைகள்",
      "addUserCategory": "+ பயனர் வகை சேர்",
      "tableTitle": "பயனர் வகை விவரங்கள்",
      "selectFileCategory": "கோப்பு வகையைத் தேர்ந்தெடுக்கவும்",
      "selectSubFileCategory": "துணை கோப்பு வகையைத் தேர்ந்தெடுக்கவும்",
      "selectUserName": "பயனர் பெயரைத் தேர்ந்தெடுக்கவும்",
      "selectUserRole": "பயனர் பங்கைத் தேர்ந்தெடுக்கவும்",
      "selectSupervisor": "மேற்பார்வையாளரைத் தேர்ந்தெடுக்கவும்",
      "editUserCategory": "பயனர் வகையைத் திருத்து",
      "loadFailed": "பயனர் வகைகளை ஏற்ற முடியவில்லை.",
      "footerCountNoun": "பயனர் வகைப்பாடுகள்",
      "duplicateCombinationError": "\"{{fileCategory}} > {{subFileCategory}}\" க்கான கட்டமைப்பு ஏற்கனவே உள்ளது. மேற்பார்வையாளர் அல்லது பயனர்களை மாற்ற, தயவுசெய்து இருக்கும் பதிவை புதுப்பிக்கவும்.",
      "editExistingRecord": "இருக்கும் பதிவைத் திருத்து →",
      "duplicateCombinationBlockedTooltip": "இந்த வகை சேர்க்கை ஏற்கனவே உள்ளது. மேலே உள்ள திருத்த இணைப்பைப் பயன்படுத்தவும்."
    },
    "intranetUserForm": {
      "updateTitle": "Intranet பயனரை புதுப்பிக்கவும்",
      "addTitle": "புதிய Intranet பயனரை சேர்க்கவும்",
      "sectionTitle": "Intranet பயனர் விவரங்கள்",
      "selectDesignation": "பதவியைத் தேர்ந்தெடுக்கவும்",
      "title": "பட்டம்",
      "firstName": "முதல் பெயர்",
      "lastName": "கடைசி பெயர்",
      "selectTitle": "பட்டத்தைத் தேர்ந்தெடுக்கவும்",
      "firstNamePlaceholder": "எ.கா.: நிமல்",
      "lastNamePlaceholder": "எ.கா.: சில்வா",
      "displayNamePlaceholder": "எ.கா.: Mr. நிமல் சில்வா",
      "emailPlaceholder": "எ.கா.: name@ag.gov.lk",
      "nicPlaceholder": "எ.கா.: 901234567V அல்லது N1234567",
      "serviceIdPlaceholder": "சேவை அடையாள எண்ணை உள்ளிடவும்",
      "selectUserRole": "பயனர் பங்கைத் தேர்ந்தெடுக்கவும்",
      "selectUserRoleToAdd": "சேர்க்க பயனர் பங்கைத் தேர்ந்தெடுக்கவும்",
      "addUserRole": "பயனர் பங்கைச் சேர்",
      "noRolesAvailable": "பங்குகள் இல்லை",
      "addRole": "பங்கைச் சேர்",
      "selectRoleFirst": "முதலில் பங்கைத் தேர்ந்தெடுக்கவும்",
      "defaultRole": "இயல்புநிலை பங்கு",
      "removeRole": "{{roleName}} ஐ அகற்று",
      "atLeastOneRole": "குறைந்தது ஒரு பயனர் பங்கு தேர்ந்தெடுக்கப்பட வேண்டும்.",
      "noRolesData": "பயனர் பங்குகளுக்கான தரவு இல்லை.",
      "selectRoleThenAdd": "பயனர் பங்கைத் தேர்ந்தெடுத்து + ஐ கிளிக் செய்யவும்.",
      "roleResolveFailed": "தேர்ந்தெடுத்த பங்கை கண்டறிய முடியவில்லை. பட்டியலிலிருந்து பங்கைத் தேர்ந்தெடுக்கவும்.",
      "rolesResolveFailed": "ஒன்று அல்லது அதற்கு மேற்பட்ட பங்குகளை கண்டறிய முடியவில்லை. மீண்டும் பங்குகளைத் தேர்ந்தெடுக்கவும்.",
      "selectDefaultRole": "இயல்புநிலை பங்கைத் தேர்ந்தெடுக்கவும்.",
      "selectValidDivision": "சரியான பிரிவு/அலகைத் தேர்ந்தெடுக்கவும்.",
      "divisionInvalid": "பிரிவு/அலகு செல்லுபடியாகாது. மீண்டும் தேர்ந்தெடுக்கவும்.",
      "createSuccess": "Intranet பயனர் வெற்றிகரமாக உருவாக்கப்பட்டார்.",
      "updateSuccess": "Intranet பயனர் வெற்றிகரமாக புதுப்பிக்கப்பட்டார்."
    },
    "extranetUserForm": {
      "allExtranetUsers": "அனைத்து Extranet பயனர்கள்",
      "updateTitle": "Extranet பயனர் விவரங்களை புதுப்பி",
      "addTitle": "புதிய Extranet பயனர் சேர்",
      "sectionTitle": "Extranet பயனர் விவரங்கள்",
      "extranetAgencyName": "Extranet நிறுவன பெயர்",
      "selectExtranetAgencyName": "Extranet நிறுவன பெயரைத் தேர்ந்தெடுக்கவும்",
      "addNewAgency": "+ புதிய நிறுவனம் சேர்",
      "addNewExtranetAgency": "புதிய Extranet நிறுவனம் சேர்",
      "enterExtranetAgencyName": "Extranet நிறுவன பெயரை உள்ளிடவும்",
      "agencyNameRequired": "Extranet நிறுவன பெயர் தேவை.",
      "selectValidAgency": "சரியான Extranet நிறுவன பெயரைத் தேர்ந்தெடுக்கவும்.",
      "companyCode": "நிறுவன குறியீடு",
      "companyCodePlaceholder": "எ.கா.: ABC",
      "brn": "BRN",
      "brnPlaceholder": "BRN ஐ உள்ளிடவும்",
      "agencyUserFullName": "நிறுவன பயனரின் முழு பெயர்",
      "agencyUserFullNamePlaceholder": "நிறுவன பயனரின் முழு பெயரை உள்ளிடவும்",
      "displayNamePlaceholder": "எ.கா.: நிமல் பெரேரா",
      "agencyUserDesignation": "நிறுவன பயனரின் பதவி",
      "agencyUserDesignationPlaceholder": "நிறுவன பயனரின் பதவியை உள்ளிடவும்",
      "contactRequired": "தொடர்பு எண் தேவை.",
      "createSuccess": "Extranet பயனர் வெற்றிகரமாக உருவாக்கப்பட்டார்.",
      "updateSuccess": "Extranet பயனர் வெற்றிகரமாக புதுப்பிக்கப்பட்டார்."
    },
    "roleForm": {
      "listTitle": "பயனர் பங்குகள் & அனுமதிகள்",
      "updateTitle": "பயனர் பங்கை புதுப்பி",
      "viewTitle": "பயனர் பங்கை பார்",
      "addTitle": "புதிய பயனர் பங்கு சேர்",
      "roleNamePlaceholder": "பயனர் பங்கின் பெயரை உள்ளிடவும்",
      "codePlaceholder": "எ.கா.: SYS_AD",
      "descriptionPlaceholder": "பயனர் பங்கின் விளக்கத்தை உள்ளிடவும்",
      "atLeastOnePermission": "குறைந்தது ஒரு அனுமதி சேர்க்கப்பட வேண்டும்.",
      "atLeastOneApplication": "குறைந்தது ஒரு பயன்பாட்டைத் தேர்ந்தெடுக்கவும்.",
      "codeGenerateFailed": "குறியீட்டை உருவாக்க முடியவில்லை. பங்கு பெயரை உள்ளிடவும்.",
      "cannotInactivateWithAssignedUsers": "பயனர்கள் ஒதுக்கப்பட்டுள்ள போது இந்த பங்கை செயலற்றதாகக் குறிக்க முடியாது.",
      "createSuccess": "பங்கு வெற்றிகரமாக உருவாக்கப்பட்டது.",
      "updateSuccess": "பங்கு வெற்றிகரமாக புதுப்பிக்கப்பட்டது."
    },
    "userCategoryForm": {
      "updateTitle": "பயனர் வகையை புதுப்பி",
      "addTitle": "பயனர் வகை சேர்",
      "userNames": "பயனர் பெயர்(கள்)",
      "selectFileCategoryFirst": "முதலில் கோப்பு வகையைத் தேர்ந்தெடுக்கவும்",
      "searchSelectUsers": "பயனர்களைத் தேடி தேர்ந்தெடுக்கவும்…",
      "noUsersFound": "பயனர்கள் கிடைக்கவில்லை",
      "createSuccess": "பயனர் வகை வெற்றிகரமாக உருவாக்கப்பட்டது.",
      "updateSuccess": "பயனர் வகை வெற்றிகரமாக புதுப்பிக்கப்பட்டது."
    }
  },
  "metadata": {
    "subCategories": {
      "title": "துணை வகை மேலாண்மை",
      "addSubCategory": "+ துணை வகை உருவாக்கு",
      "tableTitle": "துணை வகை விவரங்கள்",
      "selectFileCategory": "கோப்பு வகையைத் தேர்ந்தெடுக்கவும்",
      "selectSubFileCategory": "துணை கோப்பு வகையைத் தேர்ந்தெடுக்கவும்",
      "updateSubCategory": "துணை வகையை புதுப்பி",
      "loadFailed": "துணை வகைகளை ஏற்ற முடியவில்லை.",
      "footerCountNoun": "துணை வகைகள்"
    },
    "subCategoryForm": {
      "addTitle": "துணை வகை உருவாக்கு",
      "updateTitle": "துணை வகையை புதுப்பி",
      "bindName": "Bind Name",
      "namePlaceholder": "துணை வகை பெயரை உள்ளிடவும்",
      "codePlaceholder": "பெயரிலிருந்து உருவாக்கப்படும்",
      "codeLengthError": "குறியீடு 3–5 பேரெழுத்து எழுத்துகளாக இருக்க வேண்டும்.",
      "applicableArea": "பொருந்தக்கூடிய பகுதி",
      "applicableAreaItemPlaceholder": "பொருந்தக்கூடிய பகுதியை உள்ளிடவும்",
      "addApplicableArea": "பொருந்தக்கூடிய பகுதியைச் சேர்",
      "applicableAreaEmptyAddBlocked": "மற்றொன்றைச் சேர்ப்பதற்கு முன் பொருந்தக்கூடிய பகுதியை உள்ளிடவும்.",
      "applicableAreaDuplicateError": "இந்த பொருந்தக்கூடிய பகுதி ஏற்கனவே உள்ளது.",
      "removeApplicableArea": "பொருந்தக்கூடிய பகுதியை அகற்று",
      "documentTypes": "ஆவண வகைகள்",
      "documentOptional": "விருப்பமானது",
      "documentOptionalHint": "தேர்ந்தெடுத்தால், இந்த ஆவணம் துணை வகை சரிபார்ப்பு பட்டியலில் கட்டாயமானது அல்ல.",
      "selectAllDocumentTypes": "அனைத்து ஆவண வகைகளையும் தேர்ந்தெடு",
      "createSuccess": "துணை வகை வெற்றிகரமாக உருவாக்கப்பட்டது.",
      "updateSuccess": "துணை வகை வெற்றிகரமாக புதுப்பிக்கப்பட்டது."
    },
    "courts": {
      "title": "நீதிமன்ற பெயர்கள்",
      "addCourt": "+ நீதிமன்ற பெயரைச் சேர்",
      "tableTitle": "நீதிமன்ற பெயர் விவரங்கள்",
      "courtName": "நீதிமன்ற பெயர்",
      "courtNamePlaceholder": "நீதிமன்ற பெயரை உள்ளிடவும்",
      "courtCode": "நீதிமன்ற குறியீடு",
      "courtType": "நீதிமன்ற வகை",
      "division": "பிரிவு",
      "province": "மாகாணம்",
      "district": "மாவட்டம்",
      "selectCourtType": "நீதிமன்ற வகையைத் தேர்ந்தெடுக்கவும்",
      "selectDivision": "பிரிவைத் தேர்ந்தெடுக்கவும்",
      "selectProvince": "மாகாணத்தைத் தேர்ந்தெடுக்கவும்",
      "selectDistrict": "மாவட்டத்தைத் தேர்ந்தெடுக்கவும்",
      "selectProvinceFirst": "முதலில் மாகாணத்தைத் தேர்ந்தெடுக்கவும்",
      "selectStatus": "நிலையைத் தேர்ந்தெடுக்கவும்",
      "updateCourt": "நீதிமன்ற பெயரை புதுப்பி",
      "loadFailed": "நீதிமன்ற பெயர்களை ஏற்ற முடியவில்லை.",
      "footerCountNoun": "நீதிமன்ற பெயர்கள்"
    },
    "courtForm": {
      "addTitle": "நீதிமன்ற பெயரைச் சேர்",
      "updateTitle": "நீதிமன்ற பெயரை புதுப்பி",
      "namePlaceholder": "நீதிமன்ற பெயரை உள்ளிடவும்",
      "selectCourtType": "நீதிமன்ற வகையைத் தேர்ந்தெடுக்கவும்",
      "selectDivision": "பிரிவைத் தேர்ந்தெடுக்கவும்",
      "cancelConfirm": "மாற்றங்களைச் சேமிக்காமல் ரத்து செய்ய விரும்புகிறீர்களா?",
      "createSuccess": "நீதிமன்ற பெயர் வெற்றிகரமாக சேர்க்கப்பட்டது.",
      "updateSuccess": "நீதிமன்ற பெயர் வெற்றிகரமாக புதுப்பிக்கப்பட்டது."
    },
    "languages": {
      "title": "மொழி வகைகள்",
      "addLanguage": "+ மொழி வகையைச் சேர்",
      "tableTitle": "மொழி வகை விவரங்கள்",
      "languageName": "மொழி வகை",
      "languageCode": "மொழி குறியீடு",
      "updateLanguage": "மொழி வகையை புதுப்பி",
      "loadFailed": "மொழி வகைகளை ஏற்ற முடியவில்லை.",
      "footerCountNoun": "மொழி வகைகள்"
    },
    "languageForm": {
      "addTitle": "மொழி வகையைச் சேர்",
      "updateTitle": "மொழி வகையை புதுப்பி",
      "namePlaceholder": "மொழி வகையை உள்ளிடவும்",
      "cancelConfirm": "மாற்றங்களைச் சேமிக்காமல் ரத்து செய்ய விரும்புகிறீர்களா?",
      "createSuccess": "மொழி வகை வெற்றிகரமாக சேர்க்கப்பட்டது.",
      "updateSuccess": "மொழி வகை வெற்றிகரமாக புதுப்பிக்கப்பட்டது."
    },
    "countries": {
      "title": "நாடு மேலாண்மை",
      "addCountry": "+ நாடு உருவாக்கு",
      "tableTitle": "நாடு விவரங்கள்",
      "countryName": "நாட்டின் பெயர்",
      "countryNamePlaceholder": "நாட்டின் பெயரை உள்ளிடவும்",
      "countryCode": "நாட்டு குறியீடு",
      "description": "விளக்கம்",
      "displayOrder": "காட்சி வரிசை",
      "selectStatus": "நிலையைத் தேர்ந்தெடுக்கவும்",
      "updateCountry": "நாட்டை புதுப்பி",
      "loadFailed": "நாடுகளை ஏற்ற முடியவில்லை.",
      "footerCountNoun": "நாடுகள்"
    },
    "countryForm": {
      "addTitle": "நாடு உருவாக்கு",
      "updateTitle": "நாட்டை புதுப்பி",
      "namePlaceholder": "நாட்டின் பெயரை உள்ளிடவும்",
      "descriptionPlaceholder": "விளக்கத்தை உள்ளிடவும்",
      "cancelConfirm": "மாற்றங்களைச் சேமிக்காமல் ரத்து செய்ய விரும்புகிறீர்களா?",
      "createSuccess": "நாடு வெற்றிகரமாக உருவாக்கப்பட்டது.",
      "updateSuccess": "நாடு வெற்றிகரமாக புதுப்பிக்கப்பட்டது."
    },
    "nationalities": {
      "title": "தேசிய மேலாண்மை",
      "addNationality": "+ தேசியம் உருவாக்கு",
      "tableTitle": "தேசிய விவரங்கள்",
      "nationalityName": "பெயர்",
      "nationalityNamePlaceholder": "தேசிய பெயரை உள்ளிடவும்",
      "nationalityCode": "குறியீடு",
      "description": "விளக்கம்",
      "descriptionPlaceholder": "விளக்கத்தை உள்ளிடவும்",
      "displayOrder": "காட்சி வரிசை",
      "updatedAt": "புதுப்பிக்கப்பட்ட நேரம்",
      "selectStatus": "நிலையைத் தேர்ந்தெடுக்கவும்",
      "updateNationality": "தேசியத்தை புதுப்பி",
      "viewTitle": "தேசிய விவரங்கள்",
      "loadFailed": "தேசியங்களை ஏற்ற முடியவில்லை.",
      "footerCountNoun": "தேசியங்கள்"
    },
    "nationalityForm": {
      "addTitle": "தேசியம் உருவாக்கு",
      "updateTitle": "தேசியத்தை புதுப்பி",
      "namePlaceholder": "தேசிய பெயரை உள்ளிடவும்",
      "cancelConfirm": "மாற்றங்களைச் சேமிக்காமல் ரத்து செய்ய விரும்புகிறீர்களா?",
      "createSuccess": "தேசியம் வெற்றிகரமாக உருவாக்கப்பட்டது.",
      "updateSuccess": "தேசியம் வெற்றிகரமாக புதுப்பிக்கப்பட்டது."
    },
    "policeStations": {
      "title": "போலீஸ் நிலையங்கள்",
      "addPoliceStation": "+ போலீஸ் நிலையம் சேர்",
      "tableTitle": "போலீஸ் நிலைய விவரங்கள்",
      "name": "போலீஸ் நிலையம்",
      "code": "குறியீடு",
      "policeDivision": "போலீஸ் பிரிவு",
      "district": "மாவட்டம்",
      "selectDistrict": "மாவட்டத்தைத் தேர்ந்தெடுக்கவும்",
      "selectPoliceDivision": "போலீஸ் பிரிவைத் தேர்ந்தெடுக்கவும்",
      "updatePoliceStation": "போலீஸ் நிலையத்தை புதுப்பி",
      "loadFailed": "போலீஸ் நிலையங்களை ஏற்ற முடியவில்லை.",
      "footerCountNoun": "போலீஸ் நிலையங்கள்"
    },
    "policeStationForm": {
      "addTitle": "போலீஸ் நிலையம் உருவாக்கு",
      "updateTitle": "போலீஸ் நிலையத்தை புதுப்பி",
      "name": "பெயர்",
      "namePlaceholder": "போலீஸ் நிலைய பெயரை உள்ளிடவும்",
      "nameLengthError": "பெயர் 100 எழுத்துகளை விட அதிகமாக இருக்கக்கூடாது.",
      "policeDivision": "போலீஸ் பிரிவு",
      "selectPoliceDivision": "போலீஸ் பிரிவைத் தேர்ந்தெடுக்கவும்",
      "description": "விளக்கம்",
      "descriptionPlaceholder": "விளக்கத்தை உள்ளிடவும்",
      "active": "செயலில்",
      "createSuccess": "போலீஸ் நிலையம் வெற்றிகரமாக உருவாக்கப்பட்டது.",
      "updateSuccess": "போலீஸ் நிலையம் வெற்றிகரமாக புதுப்பிக்கப்பட்டது."
    },
    "letterTemplates": {
      "title": "கடிதம் வார்ப்புருக்கள்",
      "tableTitle": "கடிதம் வார்ப்புரு விவரங்கள்",
      "templateName": "கடிதம் வார்ப்புரு பெயர்",
      "lastUpdatedAt": "கடைசியாக புதுப்பிக்கப்பட்ட நேரம்",
      "lastUpdatedBy": "கடைசியாக புதுப்பித்தவர்",
      "selectFileCategory": "கோப்பு வகையைத் தேர்ந்தெடுக்கவும்",
      "selectFileCategoryFirst": "முதலில் கோப்பு வகையைத் தேர்ந்தெடுக்கவும்",
      "selectSubFileCategory": "துணை கோப்பு வகையைத் தேர்ந்தெடுக்கவும்",
      "selectSubFileCategoryFirst": "முதலில் துணை கோப்பு வகையைத் தேர்ந்தெடுக்கவும்",
      "selectTemplateName": "கடிதம் வார்ப்புரு பெயரைத் தேர்ந்தெடுக்கவும்",
      "selectStatus": "நிலையைத் தேர்ந்தெடுக்கவும்",
      "editTemplateName": "வார்ப்புரு பெயரைத் திருத்து",
      "loadFailed": "கடிதம் வார்ப்புருக்களை ஏற்றுவது தோல்வியடைந்தது.",
      "footerCountNoun": "கடிதம் வார்ப்புருக்கள்"
    },
    "letterTemplateForm": {
      "updateTitle": "வார்ப்புரு பெயரைத் திருத்து",
      "namePlaceholder": "கடிதம் வார்ப்புரு பெயரை உள்ளிடவும்",
      "viewTemplate": "கடிதம் வார்ப்புருவைக் காண்க",
      "previewUnavailable": "கடிதம் வார்ப்புரு முன்னோட்டம் கிடைக்கவில்லை.",
      "cancelConfirm": "சேமிக்கப்படாத மாற்றங்களுடன் ரத்து செய்ய விரும்புகிறீர்களா?",
      "updateSuccess": "கடிதம் வார்ப்புரு வெற்றிகரமாக புதுப்பிக்கப்பட்டது."
    },
    "subsidiaryTasks": {
      "title": "துணைப் பணிகள்",
      "addSubsidiaryTask": "+ துணைப் பணியைச் சேர்",
      "tableTitle": "துணைப் பணி விவரங்கள்",
      "subsidiaryTask": "துணைப் பணி",
      "description": "விளக்கம்",
      "lastUpdatedAt": "கடைசியாக புதுப்பிக்கப்பட்ட நேரம்",
      "selectSubsidiaryTask": "துணைப் பணியைத் தேர்ந்தெடுக்கவும்",
      "selectStatus": "நிலையைத் தேர்ந்தெடுக்கவும்",
      "editSubsidiaryTask": "துணைப் பணியைத் திருத்து",
      "loadFailed": "துணைப் பணிகளை ஏற்றுவது தோல்வியடைந்தது.",
      "footerCountNoun": "துணைப் பணிகள்"
    },
    "subsidiaryTaskForm": {
      "addTitle": "புதிய துணைப் பணியைச் சேர்",
      "updateTitle": "துணைப் பணியைத் திருத்து",
      "namePlaceholder": "துணைப் பணியை உள்ளிடவும்",
      "descriptionPlaceholder": "விளக்கத்தை உள்ளிடவும்",
      "cancelConfirm": "சேமிக்கப்படாத மாற்றங்களுடன் ரத்து செய்ய விரும்புகிறீர்களா?",
      "createSuccess": "துணைப் பணி வெற்றிகரமாக சேர்க்கப்பட்டது.",
      "updateSuccess": "துணைப் பணி வெற்றிகரமாக புதுப்பிக்கப்பட்டது."
    },
    "caseScenarios": {
      "title": "வழக்கு காட்சிகள்",
      "addCaseScenario": "+ வழக்கு காட்சியைச் சேர்",
      "tableTitle": "வழக்கு காட்சி விவரங்கள்",
      "titleColumn": "தலைப்பு",
      "description": "விளக்கம்",
      "lastUpdatedAt": "கடைசியாக புதுப்பிக்கப்பட்ட நேரம்",
      "selectTitle": "தலைப்பைத் தேர்ந்தெடுக்கவும்",
      "selectStatus": "நிலையைத் தேர்ந்தெடுக்கவும்",
      "editCaseScenario": "வழக்கு காட்சியைத் திருத்து",
      "loadFailed": "வழக்கு காட்சிகளை ஏற்றுவது தோல்வியடைந்தது.",
      "footerCountNoun": "வழக்கு காட்சிகள்",
      "infoPanelTitle": "வழக்கு காட்சிகள்",
      "infoEmpty": "வழக்கு காட்சிகள் எதுவும் இல்லை.",
      "infoLoadFailed": "வழக்கு காட்சிகளை ஏற்ற முடியவில்லை."
    },
    "caseScenarioForm": {
      "addTitle": "புதிய வழக்கு காட்சியைச் சேர்",
      "updateTitle": "வழக்கு காட்சியைத் திருத்து",
      "titlePlaceholder": "தலைப்பை உள்ளிடவும்",
      "descriptionPlaceholder": "விளக்கத்தை உள்ளிடவும்",
      "uploadPdf": "பதிவேற்று",
      "upload": "பதிவேற்று",
      "view": "பார்",
      "viewDocument": "{{name}} முன்னோட்டம்",
      "removeDocument": "{{name}} ஐ நீக்கு",
      "uploading": "பதிவேற்றுகிறது…",
      "remove": "நீக்கு",
      "removePdfTitle": "PDF ஐ நீக்கு",
      "removePdfConfirm": "பதிவேற்றப்பட்ட PDF ஆவணத்தை நீக்க விரும்புகிறீர்களா?",
      "removeSuccess": "PDF ஆவணம் வெற்றிகரமாக நீக்கப்பட்டது.",
      "removeFailed": "PDF ஆவணத்தை நீக்க முடியவில்லை.",
      "removing": "நீக்குகிறது…",
      "pdfRequired": "PDF ஆவணம் தேவை.",
      "uploadFailed": "PDF ஆவணத்தை பதிவேற்ற முடியவில்லை.",
      "cancelConfirm": "சேமிக்கப்படாத மாற்றங்களுடன் ரத்து செய்ய விரும்புகிறீர்களா?",
      "createSuccess": "வழக்கு காட்சி வெற்றிகரமாக சேர்க்கப்பட்டது.",
      "updateSuccess": "வழக்கு காட்சி வெற்றிகரமாக புதுப்பிக்கப்பட்டது."
    }
  },
  "tasks": {
    "shared": {
      "fileRefNo": "கோப்பு Ref. No.",
      "fileCategory": "கோப்பு வகை",
      "subFileCategory": "துணை கோப்பு வகை",
      "submittedAgency": "சமர்ப்பித்த நிறுவனம்",
      "taskStatus": "பணி நிலை",
      "currentWorkflowStage": "தற்போதைய பணிப்பாய்வு நிலை",
      "timeRemaining": "மீதமுள்ள நேரம்/ காலாவதி நேரம்",
      "urgencyLevel": "அவசர நிலை",
      "assignedOfficer": "ஒதுக்கப்பட்ட அதிகாரி",
      "caseNumber": "வழக்கு எண்",
      "submittedAt": "சமர்ப்பிக்கப்பட்ட நேரம்",
      "createdAt": "உருவாக்கப்பட்ட நேரம்",
      "supervisor": "மேற்பார்வையாளர்",
      "currentAssignee": "தற்போதைய ஒதுக்கப்பட்டவர்",
      "overdueTime": "காலாவதி நேரம்",
      "taskDetails": "பணி விவரங்கள்",
      "duplicateCase": "வழக்கை நகலெடு",
      "duplicating": "நகலெடுக்கிறது",
      "transferCase": "வழக்கை மாற்று",
      "transferring": "மாற்றப்படுகிறது",
      "downloadCoverNote": "சுருக்கக் குறிப்பை பதிவிறக்கு",
      "continueDraft": "வரைவைத் தொடர்",
      "opening": "திறக்கிறது",
      "removeDraft": "வரைவை அகற்று",
      "viewTaskCaseDetails": "பணி/வழக்கு விவரங்களைக் காண்க",
      "updateTaskCaseDetails": "பணி/வழக்கு விவரங்களை புதுப்பி",
      "retrievePhysicalFile": "இயல்பு கோப்பை மீட்டெடு",
      "markAsRead": "படித்ததாகக் குறி",
      "markAsUnread": "படிக்காததாகக் குறி",
      "updating": "புதுப்பிக்கிறது",
      "viewTaskCaseDetailsShort": "பணி/வழக்கு விவரங்களைக் காண்க",
      "configureAssignment": "ஒதுக்கீட்டை கட்டமை",
      "linkedCasesTitle": "இணைக்கப்பட்ட வழக்கு(கள்)",
      "viewLinkedCases": "இணைக்கப்பட்ட வழக்குகளைக் காண்க",
      "linkedCasesUnavailable": "இணைக்கப்பட்ட வழக்குகள் இல்லை",
      "noLinkedCases": "இந்த பணிக்கு இணைக்கப்பட்ட வழக்குகள் இல்லை.",
      "previousBack": "‹ பின்செல்",
      "nextForward": "அடுத்த ›"
    },
    "cases": {
      "breadcrumb": "பணிகள் & வழக்குகள்",
      "title": "பணிகள் & வழக்குகள்",
      "createCaseRequest": "வழக்கு கோரிக்கையை உருவாக்கு",
      "loadFailed": "பணிகள் மற்றும் வழக்குகளை ஏற்ற முடியவில்லை.",
      "notificationUpdateFailed": "அறிவிப்பு நிலையை புதுப்பிக்க முடியவில்லை.",
      "duplicateFailed": "வழக்கை நகலெடுக்க முடியவில்லை. மீண்டும் முயற்சிக்கவும்.",
      "duplicateSuccess": "வழக்கு வெற்றிகரமாக நகலெடுக்கப்பட்டது. புதிய வரைவு உருவாக்கப்பட்டது.",
      "transferFailed": "வழக்கை மாற்ற முடியவில்லை. மீண்டும் முயற்சிக்கவும்.",
      "transferSuccess": "வழக்கு வெற்றிகரமாக மாற்றப்பட்டது. வழக்காடல் வரைவு திறக்கப்பட்டது.",
      "deleteDraftFailed": "வரைவை நீக்க முடியவில்லை.",
      "deleteDraftSuccess": "வரைவு வெற்றிகரமாக நீக்கப்பட்டது.",
      "retrievalFailed": "இயல்பு கோப்பு மீட்பை கோர முடியவில்லை.",
      "retrievalSuccess": "இயல்பு கோப்பு மீட்பு தொடங்கப்பட்டது. Record Room அறிவிக்கப்பட்டது.",
      "deleteTitle": "வழக்கு கோரிக்கையை நீக்கு",
      "deleteMessage": "நீக்க விரும்புகிறீர்களா? இந்த செயலை மீளமுடியாது.",
      "activeTab": "செயலில் உள்ள பணிகள் & வழக்குகள்",
      "completedTab": "முடிக்கப்பட்ட பணிகள் & வழக்குகள்",
      "myActiveTab": "எனது செயலில் உள்ள பணிகள் & வழக்குகள்",
      "linkedActiveTab": "எனது இணைக்கப்பட்ட செயலில் உள்ள பணிகள் & வழக்குகள்",
      "createdCaseRequestsTab": "உருவாக்கப்பட்ட வழக்கு கோரிக்கைகள்",
      "tableTitle": "பணி & வழக்கு விவரங்கள்",
      "newNotificationLegend": "புதிய அறிவிப்பு பெறப்பட்டது",
      "forwardedTaskLegend": "முன்னனுப்பப்பட்ட பணி",
      "newSubTaskLegend": "புதிய துணை பணி ஒதுக்கப்பட்டது"
    },
    "assign": {
      "breadcrumb": "பணிகளை ஒதுக்கு",
      "breadcrumbAssigned": "பணிகளை ஒதுக்கு — ஒதுக்கப்பட்ட பணிகள்",
      "breadcrumbUnassigned": "பணிகளை ஒதுக்கு — ஒதுக்கப்படாத பணிகள்",
      "breadcrumbReallocation": "பணிகளை ஒதுக்கு — மறு ஒதுக்கீட்டு கோரிக்கைகள்",
      "title": "பணிகளை ஒதுக்கு",
      "subtitle": "ஒதுக்கப்படாத மற்றும் ஒதுக்கப்பட்ட பணி ஒதுக்கீடுகளை நிர்வகிக்கவும்.",
      "unassignedTab": "ஒதுக்கப்படாத பணிகள்",
      "assignedTab": "ஒதுக்கப்பட்ட பணிகள்",
      "reallocationTab": "மறு ஒதுக்கீட்டு கோரிக்கைகள்",
      "reasonToRequestReallocation": "மறு ஒதுக்கீடு கோருவதற்கான காரணம்",
      "reallocationRequestedBy": "மறு ஒதுக்கீடு கோரிய அதிகாரி",
      "reallocationRequestedAt": "மறு ஒதுக்கீடு கோரப்பட்ட நேரம்",
      "allocationModeLabel": "ஒதுக்கீட்டு முறை",
      "manualAllocation": "கைமுறை ஒதுக்கீடு",
      "roundRobinAllocation": "Round Robin ஒதுக்கீடு",
      "configureAssignment": "ஒதுக்கீட்டை கட்டமை",
      "counsel": "Counsel",
      "counselRequired": "Counsel அவசியம்.",
      "stateAttorney": "State Attorney",
      "stateAttorneyRequired": "State Attorney அவசியம்.",
      "selectUserRequired": "பயனரைத் தேர்ந்தெடுப்பது அவசியம்.",
      "supervisorRequired": "மேற்பார்வையாளர் அவசியம்.",
      "userTaskIdRequired": "பயனர் பணி id அவசியம்.",
      "assignmentFailed": "ஒதுக்கீடு தோல்வியடைந்தது.",
      "assignmentSuccess": "ஒதுக்கீடு வெற்றிகரமாக சேமிக்கப்பட்டது.",
      "cancelAssignmentTitle": "பயனர் ஒதுக்கீட்டை ரத்து செய்",
      "cancelAssignmentMessage": "ரத்து செய்ய விரும்புகிறீர்களா? சேமிக்கப்படாத மாற்றங்கள் இழக்கப்படும்.",
      "noUsersFound": "பயனர்கள் கிடைக்கவில்லை",
      "selectToReassign": "மறு ஒதுக்கீட்டிற்கு தேர்ந்தெடு",
      "selectAllFiltered": "வடிகட்டிய அனைத்தையும் தேர்ந்தெடு",
      "selectToReassignRow": "{{ref}} மறு ஒதுக்கீட்டிற்கு தேர்ந்தெடு",
      "reassignNow": "இப்போது மறு ஒதுக்கீடு",
      "reassignLater": "பின்னர் மறு ஒதுக்கீடு",
      "reassignNowInfo": "தேர்ந்தெடுக்கப்பட்ட வழக்கு(களை) மறு ஒதுக்கீடு செய்ய வழக்கறிஞர், மேற்பார்வையாளர் மற்றும் மாநில வழக்கறிஞரைத் தேர்ந்தெடுக்கவும்.",
      "reassignNowConfirmTitle": "மறு ஒதுக்கீட்டை உறுதிப்படுத்து",
      "reassignNowConfirmIntro": "தேர்ந்தெடுக்கப்பட்ட {{count}} வழக்கு(களுக்கு), பின்வரும் பயனர்கள் தேர்ந்தெடுக்கப்பட்டுள்ளனர்:",
      "reassignNowConfirmCounselLine": "1. வழக்கறிஞர் - {{name}}",
      "reassignNowConfirmSupervisorLine": "2. மேற்பார்வையாளர் - {{name}}",
      "reassignNowConfirmStateAttorneyLine": "3. மாநில வழக்கறிஞர் - {{name}}",
      "reassignNowConfirmProceed": "நீங்கள் உறுதிப்படுத்திய பிறகு, தேர்ந்தெடுக்கப்பட்ட {{count}} வழக்கு(கள்) இந்த பயனர்களுக்கு ஒதுக்கப்படும். தொடர விரும்புகிறீர்களா?",
      "reassignLaterInfo": "பின்னர் மறு ஒதுக்கீடு எனத் தேர்ந்தெடுப்பதன் மூலம், உறுதிப்படுத்தலுக்குப் பிறகு தேர்ந்தெடுக்கப்பட்ட வழக்கு(கள்) தற்போதைய ஒதுக்கப்பட்ட/பணி ஒதுக்கப்பட்ட அதிகாரியிடமிருந்து நீக்கப்படும். அதன் பிறகு, இந்த வழக்குகள் 'ஒதுக்கப்படாத பணிகள்' தாவலில் ஒதுக்கீடு-நிலுவை வழக்குகளாகத் தோன்றும்.",
      "bulkReassignSuccess": "தேர்ந்தெடுக்கப்பட்ட வழக்கு(கள்) வெற்றிகரமாக மறு ஒதுக்கீடு செய்யப்பட்டன.",
      "bulkReassignFailed": "மொத்த மறு ஒதுக்கீடு தோல்வியடைந்தது.",
      "reassignNowConfirmTitle": "மறு ஒதுக்கீட்டை உறுதிப்படுத்தவும்",
      "reassignNowConfirmIntro": "தேர்ந்தெடுக்கப்பட்ட {{count}} வழக்கு(களுக்கு), பின்வரும் பயனர்கள் தேர்ந்தெடுக்கப்பட்டுள்ளனர்:",
      "reassignNowConfirmOutro": "உறுதிப்படுத்திய பிறகு, தேர்ந்தெடுக்கப்பட்ட {{count}} வழக்கு(கள்) இந்த பயனர்களுக்கு ஒதுக்கப்படும். தொடர விரும்புகிறீர்களா?",
      "selectCasesToReassign": "மறு ஒதுக்கீடு செய்ய குறைந்தபட்சம் ஒரு வழக்கைத் தேர்ந்தெடுக்கவும்.",
      "mixedCategoryReassignError": "தேர்ந்தெடுக்கப்பட்ட வழக்குகள் ஒரே கோப்பு வகை மற்றும் துணை கோப்பு வகையைப் பகிர்ந்து கொள்ள வேண்டும்."
    },
    "escalation": {
      "breadcrumb": "உயர்த்தல் பணிகள்",
      "breadcrumbAssigned": "உயர்த்தல் பணிகள் — ஒதுக்கப்பட்ட பணிகள்",
      "breadcrumbUnassigned": "உயர்த்தல் பணிகள் — ஒதுக்கப்படாத பணிகள்",
      "title": "உயர்த்தல் பணிகள்",
      "subtitle": "மீண்டும் ஒதுக்கீட்டுக்காக உயர்த்தப்பட்ட பணிகள் மற்றும் உயர்த்தலுக்குப் பின் ஒதுக்கப்பட்ட பணிகளை மதிப்பாய்வு செய்யவும்.",
      "unassignedTab": "ஒதுக்கப்படாத பணிகள்",
      "assignedTab": "ஒதுக்கப்பட்ட பணிகள்",
      "escalatedAt": "உயர்த்தப்பட்ட நேரம்"
    },
    "managementAssistant": {
      "breadcrumb": "வழக்கு விவரங்கள்",
      "title": "வழக்கு விவரங்கள்",
      "tableTitle": "பணி & வழக்கு விவரங்கள்",
      "tabActive": "செயலில் உள்ள பணிகள் & வழக்குகள்",
      "tabCreated": "உருவாக்கப்பட்ட வழக்கு கோரிக்கைகள்",
      "tabCompleted": "முடிக்கப்பட்ட பணிகள் & வழக்குகள்",
      "createdAt": "உருவாக்கப்பட்ட நேரம்",
      "loadFailed": "வழக்கு விவரங்களை ஏற்ற முடியவில்லை."
    },
    "details": {
      "breadcrumb": "பணி/வழக்கு விவரங்கள்",
      "title": "பணி/வழக்கு விவரங்கள்",
      "loading": "பணி விவரங்கள் ஏற்றப்படுகின்றன…",
      "caseDetailsLoadFailed": "வழக்கு விவரங்களை ஏற்ற முடியவில்லை. பின்னர் மீண்டும் முயலவும்.",
      "coverNotePdfFailed": "சுருக்கக் குறிப்பு PDF ஏற்ற முடியவில்லை.",
      "startMissingIds": "தொடங்க முடியவில்லை: வழக்கு கோரிக்கை id அல்லது பயனர் பணி id இல்லை.",
      "startFailed": "தொடங்குதல் தோல்வியடைந்தது.",
      "startSuccess": "பணி தொடங்கப்பட்டது.",
      "closureValidateFailed": "மூடுதல் செயலை சரிபார்க்க முடியவில்லை.",
      "fileReferenceNumber": "கோப்பு குறிப்பு எண்",
      "currentStage": "தற்போதைய நிலை",
      "physicalFileCustody": "இயல்பு கோப்பின் பொறுப்பு",
      "linkedFileRef": "இணைக்கப்பட்ட கோப்பு Ref. No.",
      "workflowProgress": "பணிப்பாய்வு முன்னேற்றம்",
      "legendCompleted": "முடிக்கப்பட்டது",
      "legendCurrent": "தற்போதைய",
      "legendPending": "நிலுவையில்",
      "tabCaseDetails": "வழக்கு விவரங்கள்",
      "tabCaseUpdate": "வழக்கு புதுப்பிப்பு",
      "tabDocuments": "ஆவணங்கள்",
      "tabCommunications": "தொடர்புகள்",
      "tabCaseMinutes": "வழக்கு நிமிடங்கள்",
      "tabDraftLetter": "வரைவு கடிதம்",
      "tabSubTasks": "துணை பணிகள்",
      "tabFileMovementLog": "கோப்பு நகர்வு பதிவு",
      "tabInvolvement": "பங்கேற்பு",
      "tabAuditLog": "தணிக்கை பதிவு",
      "fileMovementTitle": "கோப்பு நகர்வு பதிவு விவரங்கள்",
      "dateTime": "தேதி & நேரம்",
      "event": "நிகழ்வு",
      "fileCustody": "கோப்பு பொறுப்பு",
      "qrCheckIn": "QR உள்நுழைவு",
      "qrCheckOut": "QR வெளியேற்றம்",
      "noFileMovement": "இந்த வழக்கு கோரிக்கைக்கு கோப்பு நகர்வு செயல்பாடு இல்லை.",
      "loadingQr": "QR ஏற்றப்படுகிறது…",
      "qrUnavailable": "QR code கிடைக்கவில்லை",
      "qrAlt": "வழக்கு கோரிக்கை சுருக்கக் குறிப்பு QR code",
      "viewCoverNote": "சுருக்கக் குறிப்பைக் காண்க",
      "preparing": "தயாராகிறது…",
      "printCoverNote": "சுருக்கக் குறிப்பை அச்சிடு",
      "workflowActions": "பணிப்பாய்வு செயல்கள்",
      "reviewForwardHint": "இந்த மதிப்பாய்வு பணியை மற்ற அதிகாரிக்கு அனுப்ப முன்னனுப்பு ஐப் பயன்படுத்தவும்.",
      "completeHint": "முடிக்கும் முன் விருப்ப செயல்களைத் தேர்ந்தெடுக்கவும். இந்த பணி/வழக்கை முடிக்க முடி ஐக் கிளிக் செய்யவும்.",
      "submitHint": "சமர்ப்பிக்கும் முன் விருப்ப செயல்களைத் தேர்ந்தெடுக்கவும். இந்த பணி/வழக்கை முடித்து முன்னேற {{submitLabel}} ஐக் கிளிக் செய்யவும்.",
      "forward": "முன்னனுப்பு",
      "revert": "மீளமை",
      "reject": "நிராகரி",
      "closure": "மூடுதல்",
      "complete": "முடி",
      "submit": "சமர்ப்பி",
      "checking": "சரிபார்க்கிறது…",
      "starting": "தொடங்குகிறது…",
      "start": "தொடங்கு",
      "started": "தொடங்கப்பட்டது",
      "blockingSubTasks": "இந்த பணிப்பாய்வு நிலையில் நிலுவையில் உள்ள துணை பணிகள் உள்ளன. தொடர அவற்றை முடிக்கவும்.",
      "closureAlreadyClicked": "இந்த பணிக்கான மூடுதல் அங்கீகாரியை ஏற்கனவே தேர்ந்தெடுத்துள்ளீர்கள்.",
      "statusInProgress": "செயல்பாட்டில்",
      "custodyPendingDocumentArrival": "ஆவணம் வருவதற்காக காத்திருக்கிறது",
      "communications": {
        "loading": "தொடர்புகள் ஏற்றப்படுகின்றன…",
        "loadFailed": "தொடர்புகளை ஏற்ற முடியவில்லை.",
        "invalidCaseRequest": "வழக்கு கோரிக்கை அடையாளம் தவறானது அல்லது இல்லை.",
        "addComment": "கருத்தைச் சேர்க்கவும்",
        "addCommentPlaceholder": "கருத்தைச் சேர்க்கவும்...",
        "adding": "சேர்க்கிறது…",
        "addSuccess": "கருத்து வெற்றிகரமாக சேர்க்கப்பட்டது.",
        "addFailed": "கருத்தைச் சேர்க்க முடியவில்லை.",
        "commentRequired": "தயவுசெய்து கருத்தை உள்ளிடவும்.",
        "commentTooLong": "கருத்து {{max}} எழுத்துகள் அல்லது அதற்கு குறைவாக இருக்க வேண்டும்.",
        "commentInvalid": "கருத்தில் தவறான எழுத்துகள் உள்ளன.",
        "characters": "எழுத்துகள்",
        "visibleToExternal": "வெளிப்புற நிறுவனத்திற்குத் தெரியும்",
        "cancelTitle": "மாற்றங்களை ரத்துசெய்",
        "cancelMessage": "ரத்துசெய்ய விரும்புகிறீர்களா? சேமிக்கப்படாத மாற்றங்கள் இழக்கப்படும்.",
        "onHold": "நிறுத்தி வை",
        "resume": "மீண்டும் தொடங்கு",
        "holdSuccess": "பணி நிறுத்தி வைக்கப்பட்டது.",
        "holdFailed": "பணியை நிறுத்தி வைக்க முடியவில்லை.",
        "resumeSuccess": "பணி மீண்டும் தொடங்கப்பட்டது.",
        "resumeFailed": "பணியை மீண்டும் தொடங்க முடியவில்லை.",
        "visibleExternalWarningTitle": "வெளிப்புற நிறுவனத்திற்குத் தெரியும் தேவை",
        "visibleExternalWarningMessage": "பணி ஏன் நிறுத்தி வைக்கப்படுகிறது என்பதை வெளிப்புற நிறுவனம் அறிய 'வெளிப்புற நிறுவனத்திற்குத் தெரியும்' என்பதைத் தேர்ந்தெடுத்து கருத்தைச் சேர்த்து பின்னர் நிறுத்தி வைக்கவும்.",
        "rtiExtension": {
          "requestButton": "Request Extension",
          "resumeButton": "Resume Upon Extension Response",
          "modalTitle": "Request for an Extension",
          "reasonLabel": "Reason for Requesting an Extension",
          "reasonPlaceholder": "Enter the reason for requesting an extension…",
          "reasonRequired": "Reason for Requesting an Extension is required.",
          "reasonTooLong": "Reason must be {{max}} characters or fewer.",
          "confirmTitle": "Submit Extension Request",
          "confirmMessage": "Are you sure you want to submit this extension request? The case will be placed on hold until you resume upon receiving a response from the external agency.",
          "requestSuccess": "Extension request submitted successfully.",
          "requestFailed": "Could not submit extension request."
        }
      }
    },
    "modals": {
      "forward": {
        "title": "பணியை முன்னனுப்பு",
        "physicalFileMovement": "இயல்பு கோப்பு நகர்வு தேவை",
        "selectDocumentMover": "ஆவண நகர்த்துபவரைத் தேர்ந்தெடுக்கவும்",
        "selectDocumentMoverRequired": "ஆவண நகர்த்துபவரைத் தேர்ந்தெடுப்பது அவசியம்.",
        "forwardTask": "பணியை முன்னனுப்பு",
        "forwarding": "முன்னனுப்புகிறது…",
        "forwardSuccess": "பணி வெற்றிகரமாக முன்னனுப்பப்பட்டது.",
        "forwardFailed": "முன்னனுப்புதல் தோல்வியடைந்தது.",
        "loadUsersFailed": "பயனர்களை ஏற்ற முடியவில்லை.",
        "loadMoversFailed": "ஆவண நகர்த்துபவர்களை ஏற்ற முடியவில்லை.",
        "discardTitle": "மாற்றங்களை நிராகரிக்கவா?",
        "discardMessage": "ரத்து செய்தால் உங்கள் மாற்றங்கள் இழக்கப்படும்."
      },
      "revert": {
        "title": "பணியை மீளமை",
        "revertToStage": "மீளமைக்கும் நிலை",
        "selectStage": "நிலையைத் தேர்ந்தெடுக்கவும்",
        "selectUser": "பயனரைத் தேர்ந்தெடுக்கவும்",
        "reallocationReason": "மறு ஒதுக்கீடு கோருவதற்கான காரணம்",
        "reallocationReasonPlaceholder": "மறு ஒதுக்கீடு கோருவதற்கான காரணத்தை உள்ளிடவும்",
        "reallocationReasonRequired": "மறு ஒதுக்கீடு கோருவதற்கான காரணம் அவசியம்.",
        "reallocationReasonTooLong": "காரணம் அதிகபட்சம் {{max}} எழுத்துகள் மட்டுமே.",
        "revertTask": "பணியை மீளமை",
        "reverting": "மீளமைக்கிறது…",
        "revertSuccess": "பணி வெற்றிகரமாக மீளமைக்கப்பட்டது.",
        "revertFailed": "மீளமைப்பு தோல்வியடைந்தது.",
        "stageRequired": "மீளமைக்கும் நிலை அவசியம்.",
        "userRequired": "பயனரைத் தேர்ந்தெடுப்பது அவசியம்.",
        "userTaskRequired": "பயனர் பணி id அவசியம்.",
        "loadStagesFailed": "ஏற்ற முடியவில்லை",
        "loadUsersFailed": "ஏற்ற முடியவில்லை",
        "loadMoversFailed": "ஏற்ற முடியவில்லை",
        "subtaskConfirmTitle": "துணைப் பணிகள் நடந்து கொண்டிருக்கின்றன",
        "subtaskConfirmMessage": "ஒன்று அல்லது அதற்கு மேற்பட்ட துணைப் பணிகள் இன்னும் நடந்து கொண்டிருக்கின்றன. மீளமைப்பது அவற்றை பாதிக்கலாம். தொடரவா?",
        "subtaskWarning": "ஒன்று அல்லது அதற்கு மேற்பட்ட துணைப் பணிகள் இன்னும் நடந்து கொண்டிருக்கின்றன. மீளமைப்பதற்கு முன் உறுதிப்படுத்தவும்."
      }
    }
  },
  "caseScenarios": {
    "breadcrumb": "வழக்கு சூழல்கள்",
    "title": "வழக்கு சூழல்கள்",
    "loading": "வழக்கு சூழல்கள் ஏற்றப்படுகிறது…",
    "none": "PDF உடன் செயலில் உள்ள வழக்கு சூழல்கள் இல்லை.",
    "loadFailed": "வழக்கு சூழல்களை ஏற்ற முடியவில்லை.",
    "viewPdf": "PDF காண்க",
    "pdfTitle": "வழக்கு சூழல் ஆவணம்",
    "loadingPdf": "PDF ஏற்றப்படுகிறது…",
    "pdfLoadFailed": "வழக்கு சூழல் PDF ஐ ஏற்ற முடியவில்லை."
  },
  "notifications": {
    "breadcrumb": "அறிவிப்புகள்",
    "title": "அறிவிப்புகள்",
    "markAllRead": "அனைத்தையும் படித்ததாகக் குறி",
    "marking": "குறிக்கிறது…",
    "allTab": "அனைத்து அறிவிப்புகள் ({{count}})",
    "unreadTab": "படிக்காதவை ({{count}})",
    "loading": "அறிவிப்புகள் ஏற்றப்படுகின்றன…",
    "noUnread": "படிக்காத அறிவிப்புகள் இல்லை.",
    "none": "அறிவிப்புகள் இல்லை.",
    "loadFailed": "அறிவிப்புகளை ஏற்ற முடியவில்லை.",
    "markAllFailed": "அறிவிப்புகளை படித்ததாகக் குறிக்க முடியவில்லை.",
    "markReadFailed": "அறிவிப்பை படித்ததாகக் குறிக்க முடியவில்லை.",
    "defaultTitle": "அறிவிப்பு",
    "caseRef": "வழக்கு குறிப்பு",
    "showingRange": "{{total}} அறிவிப்பில் {{start}} முதல் {{end}} வரை காட்டப்படுகிறது",
    "showingRange_plural": "{{total}} அறிவிப்புகளில் {{start}} முதல் {{end}} வரை காட்டப்படுகிறது",
    "templates": {
      "caseAssignment": {
        "title": "வழக்கு ஒதுக்கீடு",
        "body": "ஒரு பணி அல்லது வழக்கு ({{ref}}) உங்கள் பணிப்பாய்வு நிலைக்கு ஒதுக்கப்பட்டுள்ளது. விவரங்களை மதிப்பாய்வு செய்து தேவையான செயல்களை மேற்கொள்ளவும்."
      }
    }
  },
  "mailRoom": {
    "breadcrumb": "வழக்கு சமர்ப்பிப்பு கோரிக்கைகள்",
    "title": "வழக்கு சமர்ப்பிப்பு கோரிக்கைகள்",
    "loadFailed": "வழக்கு சமர்ப்பிப்பு கோரிக்கைகளை ஏற்ற முடியவில்லை.",
    "tableTitle": "வழக்கு சமர்ப்பிப்பு கோரிக்கை விவரங்கள்",
    "physicalFileStatus": "இயல்பு கோப்பு நிலை",
    "fileDeliveryMethod": "கோப்பு வழங்கல் முறை",
    "fileMovementDateTime": "கோப்பு நகர்வு தேதி & நேரம்",
    "physicalFileCustody": "இயல்பு கோப்பின் தற்போதைய பொறுப்பு",
    "viewCoverNote": "சுருக்கக் குறிப்பைக் காண்க"
  },
  "recordRoom": {
    "breadcrumb": "முடிக்கப்பட்ட கோப்புகள்",
    "title": "முடிக்கப்பட்ட கோப்புகள்",
    "loadFailed": "முடிக்கப்பட்ட கோப்புகளை ஏற்ற முடியவில்லை.",
    "tableTitle": "முடிக்கப்பட்ட கோப்பு விவரங்கள்",
    "caseCompletedAt": "வழக்கு முடிக்கப்பட்ட நேரம்",
    "physicalFileStatus": "இயல்பு கோப்பு நிலை",
    "fileMovementDateTime": "கோப்பு நகர்வு தேதி & நேரம்",
    "physicalFileCustody": "இயல்பு கோப்பின் தற்போதைய பொறுப்பு",
    "storageLocation": "சேமிப்பு இடம்",
    "viewCoverNote": "சுருக்கக் குறிப்பைக் காண்க",
    "coverNoteUnavailable": "சுருக்கக் குறிப்பு கிடைக்கவில்லை (வழக்கு கோரிக்கை id இல்லை)",
    "updateStorageLocation": "சேமிப்பு இடத்தை புதுப்பி"
  },
  "qrScanningLog": {
    "breadcrumb": "QR ஸ்கேனிங் பதிவு",
    "title": "QR ஸ்கேனிங் பதிவு",
    "tableTitle": "QR ஸ்கேன் நிகழ்வு விவரங்கள்",
    "fileRef": "கோப்பு எண்",
    "fileCategory": "கோப்பு வகை",
    "subFileCategory": "துணை கோப்பு வகை",
    "event": "நிகழ்வு",
    "eventAt": "நிகழ்வு தேதி & நேரம்",
    "systemAutomated": "சிஸ்டம் தானியங்கி",
    "viewResult": "விளைவைக் காண்க",
    "view": "காட்சி",
    "caseRequestId": "வழக்கு கோரிக்கை ID",
    "checkedInBy": "சேர்த்தவர்",
    "role": "பங்கு",
    "checkedInAt": "சேர்க்கப்பட்ட நேரம்",
    "destination": "இலக்கு",
    "receiverName": "பெறுநரின் பெயர்",
    "divisionUnit": "பிரிவு / அலகு",
    "designation": "பதவி",
    "proceedToScanQr": "QR ஐ ஸ்கேன் செய்யவும்",
    "scanQrCode": "QR கோடைக் ஸ்கேன் செய்யவும்",
    "scanInstruction": "உடல் கோப்பின் QR குறியீட்டின் மீது QR ஸ்கேன் சாதனத்தை வைத்து, உடல் கோப்பை பெற்றுக்கொண்டதை உறுதிப்படுத்தி ஏற்றுக்கொள்ளுங்கள். QR ஸ்கேன் சாதனம் USB கேபிளால் இணைக்கப்பட்டிருப்பதை உறுதிசெய்யவும். QR ஸ்கேன் வெற்றிகரமாக முடிந்தால், கோப்பு குறிப்பு எண் கீழே தோன்றும்.",
    "scanInstructionDetail": "சரிபார்ப்பை முடிக்க QR கோடையை ஸ்கேன் பிரேமுக்குள் வைக்கவும். உடல் கோப்பின் செயல்முறையை தொடரலாம்.",
    "scanPlaceholder": "QR ஸ்கேன் முன்னோட்டம்"
  },
  "dashboards": {
    "breadcrumb": "டாஷ்போர்டுகள் & அறிக்கையிடல்",
    "title": "டாஷ்போர்டுகள்",
    "subtitle": "பங்கு அடிப்படையிலான பணிச்சுமை, SLA சமிக்ஞைகள் மற்றும் bottleneck காட்சி (mock தரவு).",
    "reportingPeriod": "அறிக்கை காலம்",
    "last7Days": "கடந்த 7 நாட்கள்",
    "last30Days": "கடந்த 30 நாட்கள்",
    "last90Days": "கடந்த 90 நாட்கள்",
    "savedPreferences": "சேமிக்கப்பட்ட விருப்பங்கள்",
    "preferencesHint": "வடிகட்டிகள் உங்கள் session க்கு நிலைத்திருக்கும்; APIகள் கிடைக்கும்போது auto-refresh இணைக்கப்படலாம் (FR61).",
    "openTasks": "திறந்த பணிகள்",
    "openTasksHint": "ஒதுக்கப்பட்ட அனைத்து பணிப்பாய்வுகளிலும்",
    "slaAtRisk": "SLA அபாயத்தில்",
    "slaAtRiskHint": "TTR சாளரத்திற்குள்",
    "overdue": "காலாவதியானவை",
    "overdueHint": "TTE கடந்தது — உயர்த்தல்களை மதிப்பாய்வு செய்யவும்",
    "avgStageDuration": "சராசரி நிலை காலம்",
    "avgStageDurationHint": "சுழலும் 30 நாட்கள்",
    "workloadGraphTitle": "பணிப்பாய்வு அடிப்படையில் பணிச்சுமை (வரைபட சுருக்கம்)",
    "activeCount": "{{count}} செயலில்",
    "workloadTableTitle": "பணிச்சுமை விவரம் (அட்டவணை)",
    "workflowColumn": "பணிப்பாய்வு",
    "activeTasksColumn": "செயலில் உள்ள பணிகள்",
    "workflows": {
      "standardProsecutionAdvice": "நிலையான குற்றச்சாட்டு ஆலோசனை",
      "civilReviewContract": "சibil மதிப்பாய்வு — ஒப்பந்தம்",
      "advisoryHumanRights": "ஆலோசனை — மனித உரிமைகள்"
    }
  },
  "reports": {
    "breadcrumb": "அறிக்கைகள்",
    "previewTitle": "அறிக்கை முன்னோட்டம்",
    "records": "பதிவுகள்",
    "reset": "மீட்டமை",
    "search": "தேடு",
    "generateReport": "அறிக்கையை உருவாக்கு",
    "generating": "உருவாக்குகிறது…",
    "generateSuccess": "அறிக்கை வெற்றிகரமாக உருவாக்கப்பட்டது.",
    "generateFailed": "அறிக்கையை உருவாக்க முடியவில்லை.",
    "exportFailed": "அறிக்கையை ஏற்றுமதி செய்ய முடியவில்லை.",
    "searchFailed": "அறிக்கை தரவை ஏற்ற முடியவில்லை.",
    "dateValidation": {
      "fromFuture": "இருந்து தேதி எதிர்காலத்தில் இருக்க முடியாது.",
      "toFuture": "வரை தேதி எதிர்காலத்தில் இருக்க முடியாது.",
      "fromAfterTo": "இருந்து தேதி வரை தேதிக்குப் பிறகு இருக்க முடியாது."
    },
    "exportOptions": "ஏற்றுமதி விருப்பங்கள்",
    "exportAs": "ஏற்றுமதி",
    "exportAsPdf": "PDF ஆக ஏற்றுமதி",
    "exportAsExcel": "Excel ஆக ஏற்றுமதி",
    "exportFormatPdf": "PDF",
    "exportFormatExcel": "Excel",
    "exportStub": "அறிக்கை API இணைக்கப்படும்போது {{format}} ஏற்றுமதி கிடைக்கும்.",
    "filters": {
      "userRoles": "பயனர் பங்கு(கள்)",
      "selectUserRoles": "பயனர் பங்கு(களை) தேர்ந்தெடுக்கவும்",
      "userNames": "பயனர் பெயர்(கள்)",
      "selectUserNames": "பயனர் பெயர்(களை) தேர்ந்தெடுக்கவும்",
      "fileCategories": "கோப்பு வகை(கள்)",
      "selectFileCategories": "கோப்பு வகை(களை) தேர்ந்தெடுக்கவும்",
      "subFileCategories": "துணை கோப்பு வகை(கள்)",
      "selectSubFileCategories": "துணை கோப்பு வகை(களை) தேர்ந்தெடுக்கவும்",
      "divisionsUnits": "பிரிவு(கள்) / அலகு(கள்)",
      "selectDivisionsUnits": "பிரிவு(கள்) / அலகு(களை) தேர்ந்தெடுக்கவும்",
      "submittedAgency": "சமர்ப்பித்த நிறுவனம்",
      "selectAgency": "நிறுவனத்தைத் தேர்ந்தெடுக்கவும்",
      "taskStatus": "பணி நிலை",
      "selectStatus": "நிலையைத் தேர்ந்தெடுக்கவும்",
      "urgencyLevel": "அவசர நிலை",
      "selectUrgencyLevel": "அவசர நிலையைத் தேர்ந்தெடுக்கவும்",
      "workflowStage": "பணிப்பாய்வு நிலை",
      "selectStage": "நிலையைத் தேர்ந்தெடுக்கவும்",
      "workflowStages": "பணிப்பாய்வு நிலை(கள்)",
      "selectWorkflowStages": "பணிப்பாய்வு நிலை(களை) தேர்ந்தெடுக்கவும்",
      "all": "அனைத்தும்",
      "workflowTemplateNames": "பணிப்பாய்வு வார்ப்புரு பெயர்(கள்)",
      "selectWorkflowTemplates": "பணிப்பாய்வு வார்ப்புரு(களை) தேர்ந்தெடுக்கவும்",
      "allocationOfficer": "ஒதுக்கீட்டு அதிகாரி(கள்)",
      "selectAllocationOfficer": "ஒதுக்கீட்டு அதிகாரி(களை) தேர்ந்தெடுக்கவும்",
      "assignedOfficer": "ஒதுக்கப்பட்ட அதிகாரி",
      "selectAssignedOfficer": "ஒதுக்கப்பட்ட அதிகாரியைத் தேர்ந்தெடுக்கவும்",
      "supervisor": "மேற்பார்வையாளர்",
      "selectSupervisor": "மேற்பார்வையாளரைத் தேர்ந்தெடுக்கவும்",
      "workflowTemplateStatus": "பணிப்பாய்வு வார்ப்புரு நிலை(கள்)",
      "selectWorkflowTemplateStatus": "பணிப்பாய்வு வார்ப்புரு நிலை(களை) தேர்ந்தெடுக்கவும்",
      "typeToSearch": "தேட குறைந்தது 3 எழுத்துகள் தட்டச்சு செய்யவும்",
      "clearSelection": "அனைத்து தேர்வுகளையும் அழிக்கவும்",
      "from": "இருந்து",
      "to": "வரை"
    },
    "upr": {
      "title": "பயனர் செயல்திறன் அறிக்கை",
      "colUserName": "பயனர் பெயர்",
      "colUserRoles": "பயனர் பங்கு(கள்)",
      "colDivisionUnit": "பிரிவு / அலகு",
      "colAssigned": "ஒதுக்கப்பட்டது",
      "colEscalated": "உயர்த்தப்பட்டது",
      "colCompleted": "முடிந்தது"
    },
    "ctr": {
      "title": "வழக்கு கண்காணிப்பு அறிக்கை",
      "colFileRef": "கோப்பு குறிப்பு எண்",
      "colFileCategory": "கோப்பு வகை",
      "colSubFileCategory": "துணை கோப்பு வகை",
      "colSubmittedAgency": "சமர்ப்பித்த நிறுவனம்",
      "colSubmittedAt": "சமர்ப்பிக்கப்பட்ட நேரம்",
      "colWorkflowStage": "பணிப்பாய்வு நிலை",
      "colAllocationOfficer": "ஒதுக்கீட்டு அதிகாரி",
      "colAssignedOfficer": "ஒதுக்கப்பட்ட அதிகாரி",
      "colSupervisor": "மேற்பார்வையாளர்",
      "colTaskStatus": "பணி நிலை",
      "colUrgencyLevel": "அவசர நிலை"
    },
    "wpr": {
      "title": "பணிப்பாய்வு செயல்திறன் அறிக்கை",
      "colWorkflowCode": "பணிப்பாய்வு குறியீடு",
      "colWorkflowTemplateStatus": "பணிப்பாய்வு வார்ப்புரு நிலை",
      "colWorkflowTemplateName": "பணிப்பாய்வு வார்ப்புரு பெயர்",
      "colFileCategory": "கோப்பு வகை",
      "colSubFileCategory": "துணை கோப்பு வகை",
      "colAllocationOfficer": "ஒதுக்கீட்டு அதிகாரி",
      "colWorkflowStage": "பணிப்பாய்வு நிலை",
      "colCasesReceived": "பெறப்பட்ட வழக்குகள்",
      "colCompleted": "முடிந்தது",
      "colInProgress": "நடப்பில்",
      "colOverdue": "காலாவதியானது",
      "colEscalated": "உயர்த்தப்பட்டது"
    }
  },
  "workflow": {
    "management": "பணிப்பாய்வு மேலாண்மை",
    "templates": {
      "breadcrumb": "பணிப்பாய்வு வார்ப்புருக்கள்",
      "title": "பணிப்பாய்வு வார்ப்புருக்கள்",
      "createNew": "+ புதிய பணிப்பாய்வு வார்ப்புருவை உருவாக்கு",
      "templateName": "பணிப்பாய்வு வார்ப்புரு பெயர்",
      "templateNamePlaceholder": "பணிப்பாய்வு வார்ப்புரு பெயரை உள்ளிடவும்",
      "selectFileCategory": "கோப்பு வகையைத் தேர்ந்தெடுக்கவும்",
      "selectSubFileCategory": "துணை கோப்பு வகையைத் தேர்ந்தெடுக்கவும்",
      "selectStatus": "நிலையைத் தேர்ந்தெடுக்கவும்",
      "allocationOfficer": "ஒதுக்கீட்டு அதிகாரி",
      "selectAllocationOfficer": "ஒதுக்கீட்டு அதிகாரியைத் தேர்ந்தெடுக்கவும்",
      "tableTitle": "பணிப்பாய்வு வார்ப்புரு விவரங்கள்",
      "workflowCode": "பணிப்பாய்வு குறியீடு",
      "workflowTemplateName": "பணிப்பாய்வு வார்ப்புரு பெயர்",
      "version": "பதிப்பு",
      "lastUpdatedBy": "கடைசியாக புதுப்பித்தவர்",
      "lastUpdatedAt": "கடைசியாக புதுப்பிக்கப்பட்ட நேரம்",
      "viewTemplate": "பணிப்பாய்வு வார்ப்புருவை காண்க",
      "editTemplate": "பணிப்பாய்வு வார்ப்புருவை திருத்து",
      "duplicateTemplate": "பணிப்பாய்வு வார்ப்புருவை நகலெடு",
      "deleteTemplate": "பணிப்பாய்வு வார்ப்புருவை நீக்கு",
      "duplicating": "நகலெடுக்கிறது…",
      "deleteTitle": "பணிப்பாய்வு வார்ப்புருவை நீக்கு",
      "entityLabel": "பணிப்பாய்வு வார்ப்புரு"
    },
    "kpi": {
      "breadcrumb": "KPI கட்டமைப்பு",
      "title": "KPI கட்டமைப்பு",
      "workflowTemplateName": "பணிப்பாய்வு வார்ப்புரு பெயர்",
      "workflowStage": "பணிப்பாய்வு நிலை",
      "kpisTitle": "முக்கிய செயல்திறன் குறிகாட்டிகள் (KPI)",
      "timeToComplete": "முடிக்க எடுக்கும் நேரம் (TTC)",
      "timeToRemind": "நினைவூட்ட எடுக்கும் நேரம் (TTR)",
      "timeToEscalate": "உயர்த்த எடுக்கும் நேரம் (TTE)",
      "days": "நாட்கள்",
      "hours": "மணிநேரம்"
    },
    "escalationRules": {
      "breadcrumb": "உயர்த்தல் விதிகள்",
      "title": "உயர்த்தல் விதிகள்",
      "workflowTemplateName": "பணிப்பாய்வு வார்ப்புரு பெயர்",
      "workflowStage": "பணிப்பாய்வு நிலை",
      "hierarchyTitle": "உயர்த்தல் படிநிலை",
      "reminderRecipient": "நினைவூட்டல் பெறுநர்",
      "escalationLevel1": "உயர்த்தல் நிலை 1 பெறுநர்",
      "escalationLevel2": "உயர்த்தல் நிலை 2 பெறுநர்",
      "selectUsers": "பயனர்(களை) தேர்ந்தெடுக்கவும்",
      "selectUserRoles": "பயனர் பங்கு(களை) தேர்ந்தெடுக்கவும்",
      "notificationOptions": "அறிவிப்பு விருப்பங்கள்",
      "systemNotification": "அமைப்பு அறிவிப்பு",
      "emailNotification": "மின்னஞ்சல் அறிவிப்பு"
    },
    "designer": {
      "title": "பணிப்பாய்வு வார்ப்புரு வடிவமைப்பாளர்",
      "loading": "பணிப்பாய்வு வார்ப்புரு ஏற்றப்படுகிறது…",
      "loadFailed": "பணிப்பாய்வு வார்ப்புருவை ஏற்ற முடியவில்லை.",
      "back": "பின்செல்",
      "saveDraft": "வரைவாக சேமி",
      "validating": "சரிபார்க்கிறது…",
      "validateWorkflow": "பணிப்பாய்வை சரிபார்",
      "activating": "செயல்படுத்துகிறது…",
      "activateWorkflow": "பணிப்பாய்வை செயல்படுத்து",
      "versionNo": "பதிப்பு எண்",
      "status": "நிலை",
      "statusDraft": "வரைவு",
      "statusActive": "செயலில்",
      "statusInactive": "செயலற்ற",
      "letterTemplate": "கடிதம் வார்ப்புரு",
      "selectLetterTemplate": "கடிதம் வார்ப்புருவைத் தேர்ந்தெடுக்கவும்",
      "selectFileCategoryFirst": "முதலில் கோப்பு வகையைத் தேர்ந்தெடுக்கவும்",
      "selectSubFileCategoryFirst": "முதலில் துணை கோப்பு வகையைத் தேர்ந்தெடுக்கவும்",
      "noSubFileCategoriesAvailable": "துணை கோப்பு வகைகள் எதுவும் இல்லை",
      "draftVersionCodeNote": "இந்த பணிப்பாய்வு வார்ப்புரு செயல்படுத்தப்படும் வரை, இங்கு காட்டப்படும் பதிப்பு எண் மற்றும் பணிப்பாய்வு குறியீடு தற்காலிகமாக ஒதுக்கப்பட்டவையாக இருக்கும்.",
      "activeOfficerEditNote": "ஒதுக்கீட்டு அதிகாரியை மட்டுமே மாற்றலாம்.",
      "saveAllocationOfficer": "சேமி",
      "allocationOfficerSaved": "ஒதுக்கீட்டு அதிகாரி வெற்றிகரமாக புதுப்பிக்கப்பட்டார்.",
      "allocationOfficerUnchanged": "சேமிப்பதற்கு முன் வேறு ஒதுக்கீட்டு அதிகாரியைத் தேர்ந்தெடுக்கவும்.",
      "allocationOfficerSaveFailed": "ஒதுக்கீட்டு அதிகாரி மாற்றத்தை சேமிக்க முடியவில்லை. மீண்டும் முயற்சிக்கவும்.",
      "activeConflictWarning": "இந்த கோப்பு வகை மற்றும் துணை கோப்பு வகையிற்கு ஏற்கனவே ஒரு பணிப்பாய்வு வார்ப்புரு உள்ளது. ஏற்கனவே உள்ள செயலில் உள்ள பணிப்பாய்வு வார்ப்புருவை மாற்ற முயற்சிக்கவில்லை என்பதை உறுதிப்படுத்தவும்.",
      "canvasAriaLabel": "பணிப்பாய்வு canvas",
      "start": "தொடக்கம்",
      "end": "முடிவு",
      "addNext": "+ அடுத்த நிலையை சேர்",
      "removeStage": "நிலையை அகற்று",
      "stageBadge": "நிலை {{num}}",
      "newStage": "புதிய நிலை",
      "defaultStages": {
        "allocationOfficerAssignment": "ஒதுக்கீட்டு அதிகாரி நியமனம்",
        "closure": "மூடுதல்",
        "returnToAllocationOfficer": "ஒதுக்கீட்டு அதிகாரிக்குத் திரும்பு"
      },
      "stageProperties": "பணிப்பாய்வு நிலை பண்புகள்",
      "selectedStage": "தேர்ந்தெடுக்கப்பட்ட நிலை",
      "stageName": "நிலை பெயர்",
      "enterStageName": "நிலை பெயரை உள்ளிடவும்",
      "stageOption": "நிலை {{num}} - {{label}}",
      "selectStageHint": "பண்புகளை கட்டமைக்க canvas-இல் ஒரு நிலையைத் தேர்ந்தெடுக்கவும்.",
      "viewRoutingRules": "வழிமுறை விதிகளைக் காண்க",
      "configureRoutingRules": "வழிமுறை விதிகளை கட்டமை",
      "viewKpis": "KPIகளைக் காண்க",
      "configureKpis": "KPIகளை கட்டமை",
      "viewEscalationRules": "உயர்த்தல் விதிகளைக் காண்க",
      "configureEscalationRules": "உயர்த்தல் விதிகளை கட்டமை",
      "viewAssignment": "ஒதுக்கீட்டைக் காண்க",
      "configureAssignment": "ஒதுக்கீட்டை கட்டமை",
      "templateUpdates": "பணிப்பாய்வு வார்ப்புரு புதுப்பிப்புகள்",
      "createdUpdatedAt": "உருவாக்கப்பட்ட/புதுப்பிக்கப்பட்ட நேரம்",
      "createdUpdatedBy": "உருவாக்கியவர்/புதுப்பித்தவர்",
      "cancelWorkflowTitle": "பணிப்பாய்வு வார்ப்புருவை ரத்துசெய்",
      "cancelWorkflowMessage": "ரத்துசெய்ய விரும்புகிறீர்களா? சேமிக்கப்படாத மாற்றங்கள் இழக்கப்படும்.",
      "replaceActiveTitle": "செயலில் உள்ள பணிப்பாய்வு வார்ப்புருவை மாற்று",
      "replaceActiveMessage": "இந்த கோப்பு வகை மற்றும் துணை கோப்பு வகைக்கு மற்றொரு செயலில் உள்ள பணிப்பாய்வு வார்ப்புரு உள்ளது. அதை செயலற்றதாக்கி இதை செயல்படுத்த விரும்புகிறீர்களா?",
      "routingSaved": "வழிமுறை விதிகள் வெற்றிகரமாக சேமிக்கப்பட்டன.",
      "kpisSaved": "KPIகள் வெற்றிகரமாக சேமிக்கப்பட்டன.",
      "escalationSaved": "உயர்த்தல் விதிகள் வெற்றிகரமாக சேமிக்கப்பட்டன.",
      "closureSaved": "மூடல் ஒதுக்கீடு வெற்றிகரமாக சேமிக்கப்பட்டது.",
      "draftSaved": "பணிப்பாய்வு வார்ப்புரு வரைவாக வெற்றிகரமாக சேமிக்கப்பட்டது.",
      "activated": "பணிப்பாய்வு வார்ப்புரு வெற்றிகரமாக செயல்படுத்தப்பட்டது. இது இப்போது பணி ஒதுக்கீட்டுக்கு கிடைக்கிறது.",
      "validationResultTitle": "பணிப்பாய்வு சரிபார்ப்பு முடிவு",
      "returnToDesigner": "பணிப்பாய்வு வார்ப்புரு வடிவமைப்பாளருக்குத் திரும்பு",
      "routing": {
        "title": "வழிமுறை விதிகளை கட்டமை",
        "loading": "வழிமுறை விதிகள் ஏற்றப்படுகின்றன…",
        "defaultNextStage": "இயல்புநிலை அடுத்த நிலை",
        "allowedRevertStages": "அனுமதிக்கப்பட்ட திரும்ப நிலைகள்",
        "selectStages": "நிலை(களை)த் தேர்ந்தெடுக்கவும்",
        "cancelTitle": "வழிமுறை கட்டமைப்பை ரத்துசெய்",
        "cancelMessage": "வழிமுறை விதிகளை கட்டமைப்பதை ரத்துசெய்ய விரும்புகிறீர்களா?"
      },
      "kpiModal": {
        "title": "KPIகளை கட்டமை",
        "cancelTitle": "KPI கட்டமைப்பை ரத்துசெய்",
        "cancelMessage": "KPIகளை கட்டமைப்பதை ரத்துசெய்ய விரும்புகிறீர்களா?",
        "ttcPlaceholder": "எ.கா. 14",
        "ttrPlaceholder": "எ.கா. 12",
        "ttePlaceholder": "எ.கா. 16"
      },
      "escalation": {
        "title": "உயர்த்தல் விதிகளை கட்டமை",
        "cancelTitle": "உயர்த்தல் கட்டமைப்பை ரத்துசெய்",
        "cancelMessage": "உயர்த்தல் விதிகளை கட்டமைப்பதை ரத்துசெய்ய விரும்புகிறீர்களா?"
      },
      "assignment": {
        "title": "ஒதுக்கீட்டை கட்டமை",
        "cancelTitle": "ஒதுக்கீட்டு கட்டமைப்பை ரத்துசெய்",
        "cancelMessage": "ஒதுக்கீட்டை கட்டமைப்பதை ரத்துசெய்ய விரும்புகிறீர்களா?",
        "selectUserRole": "பயனர் பங்கைத் தேர்ந்தெடுக்கவும்",
        "assignedUser": "ஒதுக்கப்பட்ட பயனர்"
      },
      "errors": {
        "templateNameRequired": "பணிப்பாய்வு வார்ப்புரு பெயர் தேவை.",
        "fileCategoryRequired": "கோப்பு வகை தேவை.",
        "subFileCategoryRequired": "துணை கோப்பு வகை தேவை.",
        "allocationOfficerRequired": "ஒதுக்கீட்டு அதிகாரி தேவை."
      }
    }
  },
  "audit": {
    "justNow": "இப்போது",
    "minutesAgo": "{{count}} நிமி முன்பு",
    "minutesAgo_plural": "{{count}} நிமி முன்பு",
    "hoursAgo": "{{count}} மணி முன்பு",
    "hoursAgo_plural": "{{count}} மணி முன்பு",
    "yesterday": "நேற்று",
    "daysAgo": "{{count}} நாட்களுக்கு முன்பு"
  }
}